// COCHE §10.1.10 — 繁體中文 (香港). Translations TBD; copy of zh_cn until
// users (or the LLM bulk-translate tool) provide HK Traditional variants.
export default {
	common: {
		save: "儲存",
		cancel: "取消",
		delete: "刪除",
		edit: "編輯",
		search: "搜尋",
		export: "匯出",
		import: "匯入",
		confirm: "確定",
		yes: "是",
		no: "否",
		add: "新增",
		back: "返回",
		close: "關閉",
		operation: "操作",
		loading: "載入中…",
		empty: "沒有資料",
		opSuccess: "操作成功",
		opFailed: "操作失敗",
		submit: "提交",
		reset: "重設",
		reload: "重新整理",
		view: "查看",
		more: "更多",
		all: "全部",
		tip: "提示",
		confirmDelete: "確認是否刪除?",
		pleaseSelect: "請選擇",
		loadFailed: "載入失敗",
		downloadSuccess: "下載成功",
		warning: "警告",
		operationSuccess: "操作成功",
		pleaseInput: "請輸入",
		deleteSuccess: "刪除成功",
		editSuccess: "編輯成功",
		addSuccess: "新增成功",
		viewSource: "溯源",
		confirmDeleteRecord: "確定刪除當前記錄？",
		recordSeqHeader: "編號",
		detail: "詳情",
		requiredFieldHint: "缺少必填項，再次點擊提交定位至輸入欄。",
	},
	auth: {
		sessionExpired: "登入已過期，請重新登入。",
		permissionDenied: "您沒有執行此操作的權限。",
		networkError: "無法連接伺服器，請檢查網絡。",
		serverUnavailable: "服務暫時不可用，請稍後再試。",
	},
	login: {
		title: "登入",
		username: "用戶名",
		password: "密碼",
		submit: "登入",
		captcha: "驗證碼",
		rememberMe: "記住我",
		welcome: "歡迎登入",
		signIn: "登入",
		platformTitle: "科研資料庫平台",
		platformTagline: "高效採集、靈活易用的臨床科研資料解決方案",
		sxswTitle: "陝西省神經外科醫療質量控制中心資料填報系統",
		bgAlt: "背景圖",
		tabPassword: "密碼登入",
		tabSms: "驗證碼登入",
		tabWechat: "微信掃碼登入",
		usernamePh: "請輸入帳號",
		passwordPh: "請輸入密碼",
		mobilePh: "請輸入手機號",
		smsCodePh: "請輸入簡訊驗證碼",
		captchaPh: "圖形驗證碼",
		invalidMobile: "請輸入11位有效手機號",
		getCode: "取得驗證碼",
		resendCode: "{sec}秒後重新取得",
		smsSent: "驗證碼已傳送",
		copyright: "© 2026 北京醫合易生科技有限公司. 京ICP備 19052789-1",
		icpFiling: "京公網安備11011302007191",
		platformTitleMycoach: "臨床數據平台",
		platformTaglineMycoach: "Unlock Clinical Data",
		copyrightMycoach: "© 2026 Mycoach Health Limited. 保留所有權利。符合 HIPAA 與 PIPEDA 標準。",
	},
	nav: {
		dashboard: "工作台",
		patients: "病人",
		projects: "項目",
		schema: "模型",
		governance: "管治",
		settings: "設定",
		logout: "登出",
	},
	locale: {
		switcher: "語言",
		en_hk: "English",
		zh_hk: "繁體中文",
		zh_cn: "简体中文",
	},
	i18n: {
		schemaTranslate: {
			title: "模型多語言翻譯",
			scanProject: "掃描項目缺失",
			draftWithLlm: "AI 起草",
			applySelected: "儲存所選",
			columnSource: "原文",
			columnSuggestion: "AI 建議",
			columnEdited: "您的修改",
			noMissing: "該項目所有欄位均已翻譯。",
		},
	},
	imaging: {
		title: "影像查看器",
		subtitle: "COCHE Tier-B — B2 查看器 · B4 標註 (cvd_hk)",
		studies: "檢查",
		series: "序列",
		viewer: "查看器",
		reload: "重新整理",
		loading: "載入中…",
		prev: "上一張",
		next: "下一張",
		workspace: "工作台",
		metadata: "中繼資料",
		task: "任務",
		noImaging: "該病人暫無影像",
		selectSeries: "請選擇序列",
		layersShort: "圖層",
		frame: "幀",
		slice: "層",
		phase: "時相",
		axial: "橫斷",
		coronal: "冠狀",
		sagittal: "矢狀",
		play: "播放",
		pause: "暫停",
		playHint: "空格鍵播放／暫停 · ← → 相位 · ↑ ↓ 層面",
		localBuffer: "本地緩存",
		bufferLoading: "已載入 {n}/{total} 個{unit}…",
		bufferDone: "全部 {n} 個{unit}已載入 ✓",
		bufferLayers: "含 {n} 個標註層",
		wlAuto: "自動",
		display: "顯示",
		brightness: "亮度",
		contrast: "對比度",
		wlCtSoft: "CT 軟組織（400/40）",
		wlCtLung: "CT 肺窗（1500/−600）",
		wlCtBone: "CT 骨窗（2000/300）",
		wlCtBrain: "CT 腦窗（80/40）",
		wlCtVascular: "CT 血管（600/150）",
		wlBrighter: "更亮",
		wlDarker: "更暗",
		wlContrastHi: "高對比",
		wlContrastLo: "柔和",
		wlFullRange: "全範圍",
		wlCustom: "自訂",
		zoom: "縮放",
		reset: "重設",
		aiSegment: "AI 分割",
		segDialogTitle: "AI 分割 — 需要哪些結構？",
		toolGrow3d: "3D 生長",
		segPhase: "相位",
		segPhaseHint: "將堆疊中的一個回波／b 值作為體數據分割",
		segOffNotVolume: "AI 分割需要三維體積資料；此為 {n} 張獨立影像的二維序列。請改用畫筆、多邊形或區域生長描繪。",
		segOffRole: "此序列屬掃描器輔助影像而非診斷採集——依設計不納入 AI 分割。",
		structureLabel: "標籤",
		resolveNoPermission: "您的角色可裁決任務但不可建立任務——此分權為刻意設計。請由管理員或上傳者就本序列建立任務；系統直接採用現有的兩個圖層，再由您裁決。",
		acceptAs: "採用 {who}",
		acceptHint: "由其中一人決定以哪一份為準。可撤回，並記錄於該圖層的歷史中。",
		acceptNeedsSubmitted: "只有已完成的圖層可被採用——請作者先標記完成。",
		acceptedOk: "圖層 #{id} 已成為本序列的基準",
		referenceTag: "基準",
		referenceHint: "已就本序列採用。其餘圖層維持原狀——不會刪除任何內容。",
		withdrawReference: "撤回",
		resolveInTask: "以任務裁決 \u2192",
		resolveTitle: "裁決此分歧",
		resolveIntro: "任務才能讓人作出決定。它直接採用現有的兩個圖層——無需重畫——指定裁決者，並記錄決定與金標準圖層。",
		resolveReaders: "讀片者",
		resolveLabels: "標籤",
		resolveAdjHint: "由誰裁決——須為讀片者以外的人方具意義",
		resolveCreate: "建立並裁決",
		resolveCreated: "已建立任務 #{id} \u00b7 {status}",
		resolveNeedsPair: "請選擇由不同人繪製、且至少共用一個標籤的兩個圖層。",
		agreementTitle: "讀片者一致性",
		agreementSub: "本序列的兩個圖層，僅就雙方共有的標籤計分",
		agreementSameAuthor: "兩個圖層屬同一作者——此為自我比較，並非讀片者一致性。",
		agreementNoOverlap: "兩個圖層沒有共同標籤，無從計分。",
		agreementHint: "Dice 為重疊程度；kappa 為超出隨機的一致程度。建立任務可納入完整讀片小組、裁決者與金標準圖層。",
		meanDice: "平均 Dice",
		voxelsA: "體素 A",
		voxelsB: "體素 B",
		segBackend: "運算位置",
		segBackendLocal: "本機（CPU）",
		segBackendGpu: "GPU 節點（西安）",
		segBackendHint: "GPU 節點不會被自動選用——需明確選擇；選用後若節點不可用即直接失敗，不會退回 CPU，以免把 CPU 結果誤認為 GPU 結果。",
		segQuality: "質量",
		segFull: "全解析度",
		segFast: "快速（3 mm）",
		acrossSlices: "跨層面",
		keySlices: "個關鍵層",
		prevKey: "上一關鍵層",
		nextKey: "下一關鍵層",
		copyPrev: "← 複製到上一層",
		copyNext: "複製到下一層 →",
		interpolate: "在關鍵層之間插值",
		interpolated: "已填充 {n} 層",
		segTarget: "目標",
		segStructures: "個結構",
		segAllStructures: "模型已知的全部結構",
		segRun: "執行",
		measurements: "測量 — 來自 AI／金標準圖層的結構體積",
		measDate: "日期",
		analysisTable: "分析表 — 每個結構一行",
		analysisTableShort: "分析表",
		scopePatientEyebrow: "患者",
		allPatients: "全部患者",
		refreshList: "刷新檢查列表",
		scopeSeries: "當前序列",
		scopePatient: "整個患者",
		featLength: "範圍 mm",
		role_diagnostic: "診斷序列",
		role_localizer: "定位像",
		cine_gated: "電影序列(門控)",
		cine_gated_stack: "電影序列組",
		cine_loop: "實時環放",
		cine_multiacq: "多次採集",
		cine_frames: "幀序列",
		cine_none: "",
		nonDicomHint: "非 DICOM——沒有像素間距與採集元數據，測量以像素為單位，也沒有可去識別的標頭資訊。",
		role_calibration: "校準",
		role_radial: "放射狀層塊",
		role_fragment: "零散幀",
		role_derived: "衍生圖",
		role_capture: "屏幕截圖",
		analysisTableHint: "體積／管徑／訊號強度（× 為相對參考結構的比值），來自 AI、人工與金標準層；CSV 含全部欄",
		downloadCsv: "CSV",
		featDiam: "最大徑 mm",
		featIntensity: "訊號",
		measSeries: "序列",
		measStructure: "結構",
		measSource: "來源",
		segStarted: "分割任務已在 {backend} 啟動",
		saving: "儲存中…",
		frameUnavailable: "幀不可用（像素未快取）",
		layers: "圖層",
		newLayer: "新增圖層",
		noLayers: "尚無標註圖層",
		opacity: "透明度",
		delete: "刪除",
		deleteLayerConfirm: "刪除圖層 #{id}？此操作無法復原。",
		tools: "繪製工具",
		toolNone: "瀏覽",
		toolBrush: "畫筆",
		toolEraser: "橡皮",
		toolPolygon: "多邊形",
		toolGrow: "區域生長",
		radius: "半徑",
		tolerance: "容差",
		toolHint: "畫筆/橡皮：拖曳。多邊形：點擊頂點，雙擊閉合。區域生長：點擊種子點。每一筆都儲存到所選標籤。平移：使用「瀏覽」工具拖曳，或隨時按中鍵拖曳；滾輪縮放。切換層面：‹ › 或 ↑ ↓。",
		undo: "復原",
		redo: "重做",
		undoHint: "復原此圖層的上一次編輯（Ctrl+Z）",
		redoHint: "重做剛剛復原的編輯（Ctrl+Shift+Z）",
		sliceBack: "上一層（↓）",
		sliceFwd: "下一層（↑）",
		sliceBack5: "後退 5 層",
		sliceFwd5: "前進 5 層",
		keyShort: "關鍵",
		acrossNone: "此平面尚未繪製 {label} — 先在任一{axis}畫上。",
		acrossOne: "{label} 只有 1 個關鍵{axis}。移到另一{axis}畫上，即可在兩者之間插值。",
		acrossOffKey: "複製需從已有 {label} 的{axis}開始 — 用「◀ 關鍵 / 關鍵 ▶」跳到一個。",
		readOnlyLayer: "該圖層唯讀（僅可編輯自己的草稿圖層）。",
		submitReview: "提交審閱",
		submitHint: "任務 \u00b7 {title}",
		markDone: "\u2713 標註完成",
		markDoneHint: "凍結此圖層作為您的完成稿，之後仍可重新開啟。",
		markDoneConfirm: "將圖層 #{id} 標記為完成？完成後變為唯讀，隨時可重新開啟繼續編輯。",
		markDoneOk: "圖層 #{id} 已標記完成",
		doneTag: "已完成",
		reopen: "重新開啟編輯",
		reopenHint: "回到草稿狀態以繼續標註。",
		reopenedOk: "圖層 #{id} 已重新開啟",
		submitConfirm: "提交您的圖層？提交後變為唯讀，所有讀片者提交後自動計算一致性。",
		submitted: "已提交",
		phiRemoved: "入庫時已移除的身份資料",
		studiesShort: "項檢查",
		framesShort: "幀",
		filesShort: "個檔案",
		metaSummary: "概要",
		metaDicom: "DICOM 標頭",
		notDicom: "非 DICOM 序列",
		filterTags: "篩選標籤／屬性／值",
		followFrame: "跟隨目前幀",
		instance: "實例",
		reformatNote: "重建視圖 — 顯示第一個實例",
		tag: "標籤",
		attribute: "屬性",
		value: "值",
		chooseLabels: "選擇標籤",
		labelName: "標籤名稱",
		addLabel: "新增標籤",
		presetPick: "選擇一組 — 一鍵建立圖層",
		presetNone: "此模態沒有對應的組合 — 請在下方逐個選擇",
		pickLabels: "或逐個選擇標籤",
		labelsForModality: "適用於 {modality}",
		labelsAll: "全部標籤",
		labelsOther: "其他模態",
		labelNameHint: "標籤名稱，例如 左心室疤痕",
		labelCodeHint: "代碼是永久鍵值 — 筆跡、一致性評分與匯出都以它比對。由名稱自動產生，除非需要指定代碼，否則不必修改。",
		cancel: "取消",
		create: "建立",
		assignedOnlyBadge: "您只看到分配給您的序列",
		assignedOnlyHint: "沒有任務管理權限的成員只會看到自己作為標註者或裁決者的任務所屬序列。",
		seriesNotVisible: "該序列未分配給您 — 已改為顯示分配給您的序列。",
	},
	imagingWs: {
		size: "大小",
		title: "影像工作台",
		subtitle: "COCHE Tier-B — 檢查 · 上傳 · AI 分割任務 · 標註任務",
		noProject: "未選擇項目 — 請從項目內開啟，或在 URL 中加入 ?projectId=。",
		reload: "重新整理",
		upload: "上傳",
		purge: "清空項目影像數據",
		analysisCsv: "分析表 CSV",
		toAnalytics: "→ 科研分析數據集",
		toAnalyticsDone: "{rows} 行結構數據已登記為數據集 imaging_features v{version}",
		cpuOnly: "僅 CPU",
		gpuNotDefault: "已設定 GPU 節點，但不在自動路徑上；如需使用，請在 AI 分割對話框中選擇。",
		gpuUnreachable: "沒有 GPU 節點回應；分割於本機執行。",
		stageGpu: "預載體積至 GPU 節點",
		stageGpuN: "GPU 預載 {staged}/{total}",
		stageStarted: "預載任務 #{id} 已啟動，共 {n} 個體積",
		purgeConfirm: "刪除本項目影像模組的全部檢查、序列、標註和任務？此操作無法復原。",
		purged: "已清除 {n} 個序列",
		tabStudies: "檢查",
		tabJobs: "任務佇列",
		tabTasks: "標註任務",
		patient: "病人",
		date: "日期",
		modality: "模態",
		description: "描述",
		seriesCount: "序列數",
		instances: "檔案數",
		instancesHint: "DICOM SOP instance 即檔案數：一個電影序列或分割物件是一個 instance，內含多幀。",
		series: "序列",
		frames: "幀數",
		kind: "類型",
		extent: "規模",
		role: "類別",
		annotations: "圖層",
		actions: "操作",
		openViewer: "開啟查看器",
		delete: "刪除",
		deleted: "已刪除",
		deleteConfirm: "刪除「{name}」？此操作無法復原。",
		uploadTitle: "上傳影像（DICOM / NIfTI / 圖片）",
		uploadDrop: "拖入資料夾、zip 或檔案，或點擊選擇檔案",
		uploadHint: "支援任意大小的 DICOM（資料夾、zip、DICOMDIR 匯出——索引、報告與 RT 結構檔案自動略過；增強型多幀 MR / CT），以及 NIfTI、MP4 / AVI、PNG / JPEG。分 16 MB 段傳輸；入庫時自動移除病人身份資料。",
		uploading: "上傳中",
		uploadProgress: "{sent} / {total} · {rate}/s",
		uploadPart: "第 {n} / {m} 段 · 每段 16 MB，失敗自動重試 3 次",
		uploadRetry: "已重試 {n} 次",
		uploadCancel: "取消上傳",
		uploadCancelled: "上傳已取消",
		etaMeasuring: "正在測速…",
		etaSoon: "不到 1 分鐘",
		etaMinutes: "約剩 {n} 分鐘",
		ingestSummary: "{accepted} 個入庫 · {skipped} 個略過 · {duplicate} 個已存在 · {rejected} 個拒絕",
		chooseFolder: "選擇資料夾…",
		patientNoOpt: "病人編號（可選）",
		modalityOpt: "檢查設備類型（非 DICOM）",
		modalityHint: "DICOM 自帶設備類型；NIfTI、影片與圖片檔案沒有。未聲明時按「其他」入庫，且不會進行 AI 分割，以免誤用模型。",
		files: "個檔案",
		clear: "清空",
		startUpload: "開始上傳",
		close: "關閉",
		job: "任務",
		file: "檔案",
		bytes: "大小",
		status: "狀態",
		reason: "原因",
		backend: "後端",
		progress: "進度",
		createdBy: "建立者",
		started: "開始時間",
		duration: "耗時",
		error: "錯誤 / 結果",
		jobStarted: "任務 #{id} 已在 {backend} 啟動",
		segmentTask: "模型",
		cancel: "取消",
		newTask: "新增標註任務",
		taskTitle: "標題",
		readers: "讀片者",
		adjudicator: "仲裁者",
		threshold: "Dice 閾值",
		labels: "標籤",
		assigneesHint: "逗號分隔的用戶名，如 coche_researcher, coche_admin",
		create: "建立",
		created: "任務已建立 — 每位讀片者一個草稿圖層",
		open: "開啟",
		adjudicate: "仲裁",
		adjudicationTitle: "標註仲裁",
		gold: "金標準",
		needTwoReaders: "該任務需要兩個讀片者圖層才能仲裁。",
		readerA: "讀片者 A",
		readerB: "讀片者 B",
		diff: "差異",
		agree: "一致",
		only: "獨有",
		jumpAnnotated: "跳到已標註幀",
		perLabelDice: "各標籤一致性",
		raters: "位標註者",
		panelAgreement: "整體一致性",
		rater: "標註者",
		vsOthers: "與其他人的 Dice",
		acceptConsensus: "採納 {n} 人共識為金標準",
		consensusHint: "多數投票：超過半數標註者標記的體素予以保留。",
		tabReaders: "標註者",
		readerStats: "標註者表現",
		readerStatsHint: "由圖層、任務與編輯記錄直接推導，無需額外維護。",
		statLayers: "圖層數",
		statTasks: "任務數",
		statSubmitted: "已提交",
		statGold: "被採納為金標準",
		statGoldRate: "採納率",
		statEdits: "編輯次數",
		statDice: "與其他人的平均 Dice",
		statMinutes: "提交耗時中位數（分鐘）",
		outcome: "結果",
		accepted: "已接受",
		duplicateN: "重複",
		skippedN: "略過",
		rejectedN: "拒絕",
		alreadyHere: "已存在於：",
		history: "歷史",
		historyTitle: "圖層歷史",
		historyEvents: "編輯記錄",
		historyNone: "該圖層暫無編輯記錄。",
		historyFrom: "編輯自圖層",
		historyDecision: "仲裁記錄",
		staleLayer: "該圖層在您繪製期間已被修改，正在重新載入；最後一筆未儲存。",
		decision: "裁定",
		noteOpt: "備註（可選）",
		acceptA: "採納 A 為金標準",
		acceptB: "採納 B 為金標準",
		editA: "編輯 A → 金標準",
		editB: "編輯 B → 金標準",
		notDisputed: "任務狀態為 {status} — 僅在爭議狀態下可裁定。",
		notAdjudicator: "僅仲裁者（{user}）可裁定該任務。",
		adjudicated: "已仲裁",
		goldLayer: "金標準圖層",
		openInViewer: "在查看器中開啟",
		assignedOnly: "標註者僅可見已分配的序列",
		assignedOnlyHint: "開啟後，沒有任務管理權限的成員只會看到自己作為標註者或裁決者的任務所屬序列 — 檢查列表、查看器及所有影像請求皆然。",
		assignedOnlyNoPermission: "僅任務管理者可更改。",
		assignedOnlyBadge: "您只看到分配給您的序列",
		settingSaved: "設定已儲存",
		myTasks: "我的任務",
		myTasksHint: "您作為標註者或裁決者的任務",
		noTasksMine: "尚未有分配給您的任務",
		readersPick: "可標註的項目成員",
		adjudicatorPick: "可裁決的成員",
		aiReader: "AI 標註者（此序列最新的分割結果）",
		filterFrom: "起",
		filterTo: "止",
		filterSearch: "搜尋描述 / 患者 / 檢查號",
		filterRole: "序列角色",
		filterClear: "清除篩選",
		noMatch: "沒有符合篩選條件的檢查",
	},
	ml: {
		title: "聯邦學習與模型註冊",
		subtitle: "Flower FedAvg 跨站點訓練——只有模型權重跨網傳輸，病人資料不出站點",
		taskTitle: "訓練的是什麼模型",
		taskHint: "跨網傳輸的只有這個共享模型本身",
		outcome: "預測結局",
		outcomeLabel: "三年內主要不良心血管事件（MACE），二分類",
		modelFamily: "模型",
		modelLabel: "邏輯迴歸，跨站點以 FedAvg 聚合",
		parameters: "參數量",
		coefPlural: "個係數",
		cohort: "各站點隊列",
		cohortLabel: "每站點 {n} 例，由站點本地按自身隨機種子生成，從不外傳",
		variables: "預測變量",
		variable: "變量",
		unit: "單位",
		popDist: "人群均值 ± 標準差",
		coefficient: "全域係數",
		oddsRatio: "每 1 個標準差的 OR",
		intercept: "截距",
		standardisation: "各變量按固定的人群常數（而非各站點自身統計量）做 z 標準化，因此各站點的係數可直接比較。",
		finalModel: "最終模型",
		noCoef: "在下方選擇一次訓練任務即可查看學到的係數",
		feat: {
			age: "年齡",
			sbp: "收縮壓",
			ldl: "低密度脂蛋白膽固醇",
			hba1c: "糖化血紅蛋白",
			smoking: "吸煙",
			egfr: "估算腎小球濾過率 eGFR",
		},
		reload: "重新整理",
		startRun: "啟動聯邦訓練",
		rounds: "輪",
		minClients: "最少站點數",
		liveRun: "訓練進行中",
		runs: "聯邦訓練任務",
		noRuns: "暫無聯邦訓練任務",
		status: "狀態",
		roundsDone: "輪次",
		sites: "站點",
		waitingClients: "等待站點接入…",
		bytes: "發送位元組",
		auc: "AUC",
		loss: "損失",
		started: "開始時間",
		runDetail: "任務詳情",
		live: "即時",
		rowsTransferred: "傳輸的資料行",
		wireTitle: "網絡上實際傳輸的內容",
		wireHint: "每一條聯邦訊息的完整內容 —— 7 個 float32 模型權重，共 28 位元組，不含任何病人資料行",
		wireValues: "權重",
		wireHex: "原始位元組",
		direction: "方向",
		payload: "報文內容",
		globalToSites: "全域模型 → 各站點",
		toServer: "→ 伺服器",
		site: "站點",
		city: "城市",
		jurisdiction: "司法管轄區",
		nSamples: "樣本數",
		joinCommand: "新站點接入命令",
		copy: "複製",
		copied: "已複製",
		chartTitle: "各站點每輪損失（實線）與全域模型 AUC（虛線）",
		round: "輪次",
		models: "模型註冊表",
		noModels: "暫無已註冊模型",
		name: "名稱",
		version: "版本",
		algorithm: "演算法",
		artifactSha: "製品 SHA-256",
		job: "任務",
		stage: "階段",
		actions: "操作",
		toStaging: "預發佈",
		toProduction: "發佈到生產",
		strategy: "聚合方法",
		strategyParams: "方法參數",
		simulatedSites: "本機模擬站點",
		minClientsWarn: "所需站點數超過本機將啟動的站點數",
		checkpoints: "檢查點",
		checkpointsHint: "每一輪後的全局模型 — 可從任一輪恢復，或註冊為模型",
		noCheckpoints: "尚無檢查點",
		resumeFromHere: "從此處恢復",
		resumedFrom: "恢復自",
		resumeTitle: "恢復運行",
		resumeRounds: "運行輪數",
		stop: "停止",
		stopped: "運行已停止",
		registerCheckpoint: "註冊",
		registered: "已註冊",
		kind: "類型",
		kindFinal: "最終",
		kindCheckpoint: "檢查點",
		download: "下載權重",
		compare: "比較",
		compareTitle: "模型比較",
		baseline: "基準",
		delta: "差值相對於基準",
		clearCompare: "清除",
		logs: "日誌",
		logsTitle: "運行日誌",
		noLogs: "此運行沒有日誌",
		cancel: "取消",
	},
	timeseries: {
		title: "生理信號",
		streams: "信號流",
		viewer: "查看器",
		reload: "重新整理",
		live: "即時",
		ingestRate: "寫入速率",
	},
	interop: {
		title: "FHIR / OMOP 互操作",
		framing: "FHIR R4 匯出層 / OMOP CDM v5.4 匯出 — HAPI FHIR 伺服器與 OHDSI ETL 為正式部署形態。",
		coverage: "映射覆蓋率",
		fields: "個欄位",
		mapped: "已映射",
		review: "待覆核",
		unmapped: "未映射",
		perModel: "按模型",
		model: "模型",
		conceptMap: "概念映射表",
		field: "欄位",
		target: "目標",
		resource: "資源 / 表",
		element: "元素 / 欄",
		vocabulary: "術語集",
		code: "編碼",
		conceptId: "OMOP concept_id",
		display: "顯示名",
		unit: "單位",
		status: "狀態",
		note: "備註",
		search: "搜尋欄位 / 編碼 / 顯示名",
		save: "儲存",
		cancel: "取消",
		edit: "編輯",
		saved: "映射已儲存",
		reseed: "重設為預設映射",
		reseedConfirm: "重新套用內建預設映射？手動修改將被覆蓋。",
		lookup: "值級查找表",
		domain: "域",
		sourceValue: "來源值",
		fhir: "FHIR R4 Bundle",
		patient: "病人",
		pickPatient: "選擇病人",
		viewBundle: "檢視 FHIR Bundle",
		openRaw: "開啟原始 $everything",
		validate: "驗證整個項目",
		validating: "正在驗證所有病人…",
		resources: "資源",
		valid: "有效",
		invalid: "無效",
		bundleValid: "Bundle 通過 fhir.resources R4B 驗證",
		bundleInvalid: "Bundle 驗證失敗",
		omop: "OMOP CDM v5.4",
		download: "下載 OMOP CDM (zip)",
		preview: "預覽資料表",
		rows: "列",
		table: "資料表",
		reload: "重新整理",
		loading: "載入中…",
		noProject: "請先選擇項目",
		collapseAll: "全部收合",
		expandAll: "全部展開",
	},
	encryption: {
		title: "加密狀態",
		enabled: "已啟用",
		disabled: "未啟用",
		mysql: "MySQL",
		reload: "重新整理",
		encryptAll: "加密全部",
		decryptAll: "解密全部",
	},
	header: {
		maskedHospital: "****醫院",
		systemAdminConsole: "系統管理控制台",
		switchTenant: "切換租戶",
		configForm: "配置表單",
		switchProject: "切換項目",
		setPassword: "設定密碼",
		changePassword: "修改密碼",
		avatarSettings: "頭像設定",
		settings: "設定",
		logout: "登出",
		oldPassword: "原密碼",
		newPassword: "新密碼",
		confirmPassword: "確認密碼",
		enterOldPassword: "請輸入原密碼",
		enterNewPassword: "請輸入新密碼",
		enterConfirmPassword: "請再次輸入新密碼",
		passwordMismatch: "兩次密碼不一致",
		tenantCodePrompt: "輸入租戶編碼（必須是正確的租戶編碼）",
		passwordSetSuccess: "密碼設定成功，請重新登入",
		passwordChangeSuccess: "密碼修改成功，請重新登入",
		compactMode: "緊湊模式",
		compactModeDesc: "表單欄位橫向排列，行距更緊湊",
		darkMode: "深色模式",
		darkModeDesc: "僅本機生效，重新整理後保留",
		dataMasking: "資料脫敏",
		dataMaskingDesc: "在列表/表單中隱藏敏感欄位",
		fontTheme: "字型主題",
		fontThemeDesc: "選擇更現代的中英文字型組合，僅本機生效，立即套用",
		fontThemeModern: "現代",
		fontThemeEditorial: "嚴謹",
		fontThemeFriendly: "清新",
		betaSuffix: "（BETA）",
		languageDesc: "介面語言，切換後頁面會自動重新整理",
		changePasswordDesc: "更新登入密碼，修改後需重新登入",
		avatarSettingsDesc: "上傳或更換頭像圖片",
		modify: "修改",
		displayName: "顯示名稱",
		displayNameDesc: "應用中顯示的名稱；登入使用者名稱不可更改",
		editDisplayName: "修改顯示名稱",
		displayNamePlaceholder: "請輸入顯示名稱",
		displayNameRequired: "請輸入顯示名稱",
		displayNameLength: "顯示名稱長度需為 1–120 個字元",
		displayNameUpdated: "顯示名稱已更新",
		sectionAccount: "帳戶",
		sectionAppearance: "外觀",
		sectionPrivacy: "私隱",
	},
	followup: {
		title: "隨訪列表",
		statTotalCase: "病例總量",
		statMonthlyDue: "本月應到期訪視",
		statMonthlyDone: "本月已完成訪視",
		statMonthlyOpen: "本月未完成訪視",
		searchDate: "隨訪日期：",
		searchStatus: "隨訪狀態：",
		searchPatient: "患者姓名/編號：",
		startDate: "開始時間",
		endDate: "結束時間",
		select: "請選擇",
		input: "請輸入",
		searchBtn: "查 詢",
		resetBtn: "重 置",
		colIndex: "序號",
		colVisitPlan: "訪視計劃預覽",
		colPatientName: "患者姓名",
		colPatientNo: "患者編號",
		colVisitDate: "隨訪日期",
		colVisitName: "訪視名稱",
		colStatus: "隨訪狀態",
		colCenter: "所屬中心",
		colOperation: "操作",
		actEdit: "編輯",
		actView: "查看",
		actCancel: "取消隨訪",
		statusPending: "未隨訪",
		statusOverdue: "已超窗",
		statusDone: "已隨訪",
		fieldKeyword: "請輸入關鍵字",
		detailTitle: "隨訪詳情",
	},
	multicenter: {
		overviewTitle: "多中心概覽",
		patientTitle: "多中心患者列表",
		followupTitle: "多中心隨訪管理",
		colCenter: "中心",
		colTenant: "租戶",
		colPatientCount: "病例數",
		colFollowupCount: "隨訪數",
		colCompleteness: "完整度",
		switchProject: "切換項目",
		statCenters: "中心數量",
		statPatients: "患者總數量",
		statFollowups: "隨訪總次數",
		statOverdue: "過期未隨訪",
		newPatientTrend: "患者新增趨勢",
		today: "今日",
		thisWeek: "本週",
		thisMonth: "本月",
		thisYear: "全年",
		startDate: "開始日期",
		endDate: "結束日期",
		dateSep: "至",
		centerPatientCount: "中心患者數量",
		colRank: "排名",
		colCenterName: "中心名稱",
		colUserCount: "用戶數",
		colPatientCountAlt: "患者數量",
		patientGender: "患者性別",
		mcInfo: "多中心資訊",
		caseCount: "病例數",
		departmentCount: "科室",
		mapCenters: "多中心分佈圖",
		mapPatients: "患者區域分佈圖",
		caseFilter: "病例數量篩選",
		all: "ALL",
		hospitalName: "醫院名稱：",
		departmentName: "科室名稱：",
		projectName: "項目名稱：",
		patientCountLabel: "病例數量：",
		emptyData: "暫無資料",
	},
	manage: {
		auditLog: "審計日誌",
		piiRule: "PII規則配置",
		governanceInbox: "審批收件匣",
		myRequests: "我的申請",
		scopeTree: "組織架構",
		lifecycle: "生命週期",
		metadataVersioning: "模型版本",
		ingestionHardening: "匯入加固",
		ehealth: "eHealth 上傳",
		subCenter: "分中心",
		schema: "架構生成",
		agentConfig: "Agent設定",
		random: "隨機化",
		consent: "知情同意書",
	},
	databaseConfig: {
		patientBasicInfo: "患者基本資訊配置",
		databaseSection: "資料庫配置",
		followupSection: "隨訪表配置",
		colNo: "序號",
		colFormCode: "表單編碼",
		colFormName: "表單名稱",
		colModelCount: "模型數",
		colOp: "操作",
		colFollowupCode: "隨訪表單編號",
		colFollowupName: "隨訪表單名稱",
		colFollowupPlan: "關聯隨訪計劃",
		colFollowupPlanName: "關聯隨訪計劃名稱",
		btnAdd: "新增",
		btnBatchAdd: "批量新增",
		btnDelete: "刪除",
		btnEdit: "編輯",
		btnConfig: "配置",
		btnConfigFromTemplate: "從範本配置",
		btnConfigFromForm: "從項目表單配置",
		dlgEditTitle: "編輯",
		dlgAddTitle: "新增",
		dlgEditFollowupTitle: "編輯隨訪表",
		dlgAddFollowupTitle: "新增隨訪表",
		dlgFormName: "表單名稱",
		dlgFollowupName: "隨訪表單名稱",
		dlgPh: "請輸入",
		dlgCancel: "取消",
		dlgConfirm: "確定",
	},
	memberPermissions: {
		title: "人員權限",
		colNo: "序號",
		colTenant: "租戶",
		colUsername: "用戶名",
		colNickname: "暱稱",
		colFuncPermission: "功能權限",
		colDataPermission: "數據權限",
		colActions: "操作",
		btnConfigure: "配置",
		btnEdit: "修改",
		noRolesAssigned: "（未分配角色）",
		scopeCount: "範圍：{f} 個表單 · {m} 個模型",
		actEditRoles: "編輯功能權限",
		actEditData: "編輯數據權限",
		actRemove: "移除醫生",
		confirmRemove: "確認移除當前醫生?",
		dlgAddTitle: "多中心人員管理",
		addHint: "輸入精確的 用戶名/工號/手機號 進行搜尋；新增後可在右側表格設定功能權限與數據權限。",
		searchPh: "請輸入精確的 用戶名/工號/手機號…",
		searchNoMatch: "未找到符合的用戶 — 請檢查拼寫或使用準確帳號",
		lblAccount: "帳號",
		btnAddAnother: "新增",
		dlgFuncTitle: "功能權限配置",
		projectRolesLabel: "項目範圍內的角色（可在此編輯）",
		globalRolesLabel: "全局生效的角色（請在「用戶管理」中編輯）",
		globalRolesHint: "這些角色是在用戶層級分配的，對所有項目都生效。請在用戶管理頁中維護，本處僅作唯讀展示。",
		projectRolesEmptyButGlobal: "該用戶尚未分配項目級角色，其在本項目的權限完全來自上方的全局角色。如需為本項目單獨授權，請在此選擇。",
		projectRolesEmptyNoGlobal: "該用戶尚未分配任何角色，請在此選擇以授予項目級權限。",
		dlgDataTitle: "數據權限配置",
		dataBypassModelAdmin: "提示：該用戶擁有 Model Administrator 角色，會完全繞過數據權限過濾。下方的選擇會被保存，但在瀏覽時不會生效——這些設定僅對沒有 Model Administrator 角色的用戶起作用。",
		dataBypassProjectCreator: "提示：該用戶是本項目的創建人，會完全繞過數據權限過濾。下方的選擇會被保存，但在瀏覽時不會生效——項目創建人始終可以看到全部表單與模型。",
		sodWarnTitle: "職責分離警告 ({n} 項衝突) — 仍可保存",
		sodErrorTitle: "職責分離衝突 ({n} 項) — 該項目已開啟強制校驗，無法保存",
		sodEnforceBlocked: "職責分離衝突 — 請移除衝突角色後再保存",
		sodWarnSaved: "已保存，但存在 {n} 項職責分離警告",
	},
	sod: {
		tagPending: "（待新增）",
		tagAssigned: "（已分配）",
		violationLine: "{a} 與 {b} 衝突 ({classA} × {classB})",
	},
	scopeTree: {
		filterTenantPh: "按租戶篩選",
		visibilityTitle: "我的可見範圍",
		visibilityPrompt: "點擊『重新整理』查詢目前會話的可見項目集",
		fUserId: "用戶 ID",
		fBypass: "繞過過濾",
		bypassYes: "是 (bypass)",
		bypassNo: "否 (enforced)",
		fReason: "原因 (reason)",
		fScopePaths: "Scope paths",
		noScopePath: "— 無 scope_path 分配 —",
		fAllowedProjects: "可見項目 ID",
		bypassAll: "— bypass: 全部可見 —",
		noVisibleProject: "無可見項目 (allowed-set is empty)",
		emptyTree: "暫無組織架構數據",
		rootLabel: "全部組織",
		tagDefault: "預設",
		tagProjectCount: "{n} 項目",
		truncated: "結果已截斷 (>1000 節點)。請使用單層介面分頁載入。",
		selectHint: "請在左側選擇一個節點以查看詳情",
		dKind: "層級",
		dCode: "代碼",
		dTenant: "租戶",
		dRegulatory: "監管",
		dFederation: "聯邦模式",
		dAddress: "地址",
		dCountry: "國家",
		dRegion: "地區",
		dMission: "使命",
		dProjectCount: "所含項目數",
	},
	auditLog: {
		title: "審計日誌",
		refresh: "重新整理",
		startDate: "起始時間",
		endDate: "結束時間",
		category: "分類",
		verb: "動作 (verb)",
		targetType: "目標類型",
		outcome: "結果",
		actorUserId: "操作人 ID",
		dataSubjectId: "資料主體 ID (GDPR)",
		targetProjectCode: "項目代碼",
		search: "查詢",
		reset: "重設",
		empty: "暫無審計日誌",
		colTime: "時間",
		colActor: "操作人",
		colApp: "入口",
		colCategory: "分類",
		colVerb: "動作",
		colTarget: "目標",
		colOutcome: "結果",
		colDetail: "詳情",
		view: "查看",
		drawerTitle: "審計日誌詳情",
		eventSection: "事件",
		complianceSection: "合規元資料 (GDPR readiness)",
		integritySection: "完整性 (hash chain)",
		fId: "ID",
		fTime: "時間",
		fActor: "操作人",
		fIp: "IP",
		fApp: "入口",
		fCategory: "分類 / 動作",
		fOutcome: "結果",
		fFailureReason: "失敗原因",
		fTarget: "目標",
		fProject: "項目",
		fLawful: "lawful_basis",
		fSubject: "data_subject_id",
		fCrossBorder: "cross_border_transfer",
		yes: "是",
		no: "否",
		fDestCountry: "destination_country",
		fPrev: "prev_log_hash",
		fThis: "this_log_hash",
		changeRefSection: "關聯變更記錄",
		loadChange: "載入變更詳情",
		fTable: "表/集合",
		fPk: "主鍵",
		fOp: "操作",
		loadChangeFailed: "載入變更詳情失敗",
	},
	metaVer: {
		intro: "此頁面是 <a href=\"/api/cmdb-template/doc.html#/cmdb-metadata\" target=\"_blank\">/cmdb-metadata</a> 的唯讀檢視。版本/歷史快照按 spec §3 的三階段開關推出。規範見 extract/coche/specs/metadata-versioning.md。",
		tabLog: "評估日誌 (影子+執行)",
		tabTags: "標籤",
		tabAdapters: "格式適配器",
		colTarget: "目標",
		colPriorVer: "原版本",
		colNote: "備註",
		colCode: "編碼",
		colTag: "標籤",
		colDescription: "描述",
		colCreated: "建立時間",
		colExtensions: "副檔名",
		colName: "名稱",
		colEnabled: "啟用",
		on: "啟用",
		off: "停用",
	},
	lifecyclePage: {
		intro: "此頁面是 <a href=\"/api/cmdb-template/doc.html#/cmdb-lifecycle\" target=\"_blank\">/cmdb-lifecycle</a> 的唯讀檢視。策略和法律保留的建立走 API;執行嚴格通過審批工作流(§10.1.3)。規範見 extract/coche/specs/lifecycle-retention.md。",
		tabPolicies: "保留策略",
		tabHolds: "法律保留",
		tabLog: "評估日誌 (影子+執行)",
		colTargetType: "目標類型",
		colRetentionDays: "保留天數",
		colAgeAnchor: "年齡錨點",
		colAction: "處置動作",
		colEnabled: "啟用",
		colDescription: "描述",
		on: "啟用",
		off: "停用",
		colScope: "範圍",
		colTargetId: "目標 ID",
		colReason: "原因",
		colImposed: "施加時間",
		colReleased: "解除時間",
		active: "活躍中",
		colAgeDays: "年齡(d)",
		colRequest: "審批請求",
		colNote: "備註",
	},
	dataSync: {
		title: "數據同步",
		reload: "刷新",
		range7d: "近7天",
		range30d: "近30天",
		range90d: "近90天",
		todayNewPatients: "今日新增患者",
		todayUnits: "今日新增隨訪單元",
		last7d: "近7天",
		backlog: "待處理單元",
		backlogHint: "已枚舉未寫入的單元數",
		latestRun: "最近一次運行",
		noRuns: "尚無運行記錄",
		noData: "暫無數據",
		chartTitle: "每日更新趨勢",
		seriesUnits: "隨訪單元",
		seriesPatients: "新增患者",
		seriesErrors: "錯誤數",
		runHistory: "運行歷史",
		colBatch: "批次",
		colPhase: "階段",
		colStatus: "狀態",
		colStarted: "開始時間",
		colEnded: "結束時間",
		colDone: "完成",
		colSkip: "跳過",
		colEmpty: "空單元",
		colErrors: "錯誤",
		colNewPatients: "新增患者",
		colDocuments: "寫入文檔",
		colNote: "備註",
		detailTitle: "運行詳情",
		cacheHits: "緩存命中",
		unrouted: "未路由檢查項",
		unmappedEnums: "未匹配枚舉值",
		unmappedEnumValues: "被丟棄的枚舉取值",
		enumSynonym: "按同義詞匹配的取值",
		enumCatchAll: "歸入其他類的取值",
		unknownModels: "未知模型",
		multiRecordDropped: "無法存放的多條記錄",
		activeFilterSkipped: "跳過的有效行過濾",
		numericPercent: "數值欄位：已去除百分號",
		numericDecimal: "數值欄位：整數欄位收到小數",
		numericThreshold: "數值欄位：閾值表述未採納",
		numericUnit: "數值欄位：帶單位未採納",
		numericList: "數值欄位：多值未採納",
		numericQualitative: "數值欄位：定性描述未採納",
		numericThresholdValue: "數值欄位：閾值表述明細",
		numericUnitValue: "數值欄位：帶單位明細",
		numericListValue: "數值欄位：多值明細",
		numericQualitativeValue: "數值欄位：定性描述明細",
		groupTruncated: "另有 {n} 項未顯示",
		scalars: "其他計數",
		colItem: "項目",
		colCount: "次數",
		status: {
			running: "運行中",
			completed: "已完成",
			aborted: "已中止",
			failed: "失敗",
		},
	},
	ehealth: {
		openViewer: "開啟 eHR Viewer",
		viewerTitle: "eHR 檢視器",
		viewerIntro: "在停靠於螢幕右半邊的獨立視窗中開啟香港醫健通 <b>eHR Viewer</b>（Mode B 2.1，由 eSC Client 簽發票據），隨後由醫健通要求輸入雙重認證碼。再開啟另一位病人會取代該視窗；登出本系統會關閉該視窗。醫健通不允許其頁面被嵌入其他網站，因此無法在本頁面內直接顯示。",
		viewerOpenNonPatient: "開啟 eHR Viewer（不指定病人）",
		viewerHintWindow: "只有一個停靠視窗：在螢幕右半邊開啟，新的開啟操作會取代上一位參與者，在本系統登出會關閉它。",
		viewerHintPatient: "要開啟指定病人，請在病人頁／覆診頁頂部的病人資料列按「開啟 eHR Viewer」。",
		viewerNotMapped: "目前帳號未對應醫健通 eHR UID，只有已登記的醫健通使用者才能啟動檢視器。",
		viewerEscMissing: "伺服器未設定 eSC Client 位址，無法啟動檢視器。",
		viewerNoUrl: "醫健通未返回啟動網址。",
		viewerPopupBlocked: "瀏覽器攔截了 eHR Viewer 視窗，請允許本站彈出視窗後重試。",
		uploadReport: "上載收件匣報告（PDF）",
		uploadReportHint: "由 eHR 收件匣列印的處理摘要／例外／重新評級報告。純影像 PDF 會先 OCR（約 30 秒）。",
		reportDone: "{kind}・{state}・配對批次 {batches}、記錄 {records}",
		reportKind: "類別",
		reportTitle: "標題",
		issuedAt: "發出時間",
		parseState: "讀取",
		matchedBatches: "批次",
		matchedRecords: "記錄",
		lines: "明細",
		reconcile: "重新核對",
		noReports: "尚未上載任何報告。",
		errorCode: "錯誤代碼",
		errorField: "欄位",
		rawLine: "讀取原文",
		tabNotifications: "通知",
		poll: "向 eHealth 拉取（GPNH）",
		pollHint: "對外呼叫：取得自上次視窗以來的同意／索引鍵變更／身故等通知並套用。全日可用。",
		pollDone: "拉取完成：收到 {received}，套用 {applied}，重複 {duplicates}，未知病人 {unmatched}",
		pendingRepliesTitle: "{n} 則同意通知尚待回覆主索引鍵核對結果（7 日內）",
		colEvent: "事件",
		changes: "套用的變更",
		reply: "回覆",
		replyDue: "期限",
		previewMatch: "預覽核對",
		sendReply: "送出回覆",
		noReplyDue: "無需回覆",
		noNotifications: "尚未套用任何通知。",
		scan: "掃描記錄",
		scanHint: "登記本專案的 LABGEN 記錄（新增、修改、撤回）。僅本地操作。",
		scanDone: "掃描完成：掃描 {scanned}，登記 {registered}，修改 {amended}，撤回 {withdrawn}",
		transactions: "交易",
		txnDatetime: "交易日期時間",
		outcome: "結果",
		rows: "輸出列",
		build: "建立批次",
		buildHint: "將待上載記錄組裝為已簽署、加密的 LABGEN 批次並存於磁碟。按「上載」前不會送出。",
		buildDone: "已建立 {name}（{mode}）：納入 {included} 筆，排除 {excluded} 筆",
		modeAuto: "模式：自動",
		noBatches: "尚未建立批次。",
		colBatchName: "批次（HL7 名稱）",
		colParticipants: "病人數",
		colNotes: "建立備註",
		actions: "操作",
		files: "檔案",
		upload: "上載（SFTP）",
		checkCollected: "已收取？",
		uploadDone: "已上載——記錄轉為「已存放」，等待報告",
		remoteDir: "遠端資料夾",
		zipSha: "Zip SHA-256",
		fileKind: "類別",
		fileName: "檔案",
		bytes: "位元組",
		checksum: "SHA-256",
		open: "開啟",
		record: "記錄",
		refresh: "重新整理",
		colName: "姓名",
		colDob: "出生日期",
		colSex: "性別",
		colConsent: "同意狀態",
		colFlags: "標記",
		colQuery: "最近 PMI 查詢",
		colEligibleFrom: "可上載起始日",
		unknown: "未知",
		flagDeceased: "已歿",
		flagSuspended: "已暫停",
		flagProblem: "問題紀錄",
		neverQueried: "從未查詢",
		pmiSync: "由患者基本資料同步",
		pmiSyncHint: "由「患者基本資料」表單重新推導 PMI 身份列。僅本地操作。",
		pmiSyncDone: "同步完成：掃描 {scanned}，新增 {created}，更新 {updated}，不變 {unchanged}",
		pmiEmpty: "尚無 PMI 身份列——請先於「患者基本資料」表單新增病人，再同步。",
		majorKeys: "主索引鍵",
		lastDeposit: "最近上載",
		documents: "身份證明文件",
		docType: "類別",
		docNumber: "號碼",
		docNumberNorm: "正規化",
		docValidity: "有效性",
		docCurrent: "現行",
		docSuperseded: "已被取代",
		eligibility: "上載資格",
		eligibleYes: "可上載",
		eligibleNo: "不可上載",
		eligibilityNote: "即時依現況及有效期內的最近 PMI 查詢計算，從不儲存為旗標。",
		recordDecision: "記錄判定",
		pmiQuery: "向 eHealth 查詢（PMI Query）",
		pmiQueryHint: "經香港出口對外呼叫；eHealth 僅於平日 08:00–18:00（香港時間）回應。",
		pmiQueryDone: "PMI 查詢完成",
		keyHistory: "已被取代的主索引鍵",
		supersededAt: "取代時間",
		surname: "姓氏",
		givenName: "名字",
		reason: {
			OK_JOINING_CONSENT: "eHealth 已確認加入同意",
			NO_EHR_NUMBER: "eHealth 無此主索引鍵的參與者",
			DECEASED: "病人已登記身故",
			CONSENT_REVOKED: "對本機構的同意已撤回",
			EMERGENCY_ONLY: "僅緊急存取（只可閱覽，不可上載）",
			QUERY_STALE: "最近 PMI 查詢已逾有效期——請重新查詢",
			QUERY_UNAVAILABLE: "尚無可用的 PMI 查詢結果——請向 eHealth 查詢",
		},
		intro: "上載臨床數據至香港電子健康紀錄互通系統（eHRSS）。存放是批次通道，並非逐筆儲存的 API：紀錄先在此保存，按範疇打包、簽署，再經 SFTP 存放，其後由非同步報告判定。批次被取走並不等於已被接納。",
		tabRecords: "紀錄",
		tabBatches: "批次",
		tabPatients: "PMI 病人",
		tabRegister: "病歷登記冊",
		registerAllDomains: "全部資料範疇",
		registerHint: "按病人列出本系統持有的每一份紀錄，以及把它送交醫健通的批次。",
		registerEmpty: "本項目尚未持有臨床紀錄。",
		registerFootnote: "紀錄先在本系統建立，其後才上載，並載明承載該紀錄的批次，以證明臨床資料是由系統直接上載至醫健通，而非人手輸入。",
		cntPatients: "病人",
		cntRecords: "臨床紀錄",
		cntUploaded: "已上載至醫健通",
		cntDomains: "資料範疇",
		colSummary: "紀錄",
		colRecordDate: "紀錄日期",
		colCreatedInEmr: "於本系統建立",
		colUploaded: "上載時間",
		tabReports: "報告",
		tabMapping: "欄位對應",
		colRecordKey: "紀錄鍵值",
		colDomain: "數據範疇",
		colPatient: "病人",
		colEhrNumber: "eHR 編號",
		colTxn: "交易類別",
		colState: "狀態",
		colCreated: "在系統建立時間",
		colDeposited: "存放時間",
		colBatch: "批次",
		colLevel: "獲評級別",
		colMode: "模式",
		colTransport: "傳輸",
		colGenerated: "產生時間",
		colRecordCount: "紀錄數",
		stateHeld: "保存中",
		stateDeposited: "已存放",
		stateAccepted: "已接納",
		stateRejected: "已拒絕",
		stateRegraded: "已降級",
		stateWithdrawn: "已撤回",
		depositPending: "等待報告——存放不等於接納",
		notConfigured: "此項目未設定 eHealth 存放對象（ehealth_hcp_id 為空），只能在此檢視紀錄，無法存放。",
		disabledGlobally: "此部署未啟用 eHealth 功能（imles.ehealth.enabled=false）。",
		shadowMode: "影子模式——批次只會建立並記錄，不會實際傳送。",
		empty: "此項目尚無 eHealth 紀錄。",
	},
	ingestion: {
		intro: "唯讀檢視。攝取硬化按 spec §3 的三階段開關推出(Phase A=休眠 / Phase B=影子 / Phase C=enforce)。SFTP 伺服器獨立 gated 在 <code>imles.ingestion.sftp.enabled</code>。規範見 extract/coche/specs/ingestion-hardening.md。",
		tabChecksum: "校驗碼 (SHA-256)",
		tabRejections: "拒絕佇列",
		tabDedup: "去重表",
		tabSftp: "SFTP 工作階段",
		hashPlaceholder: "按 SHA-256 查找 (64 hex)",
		colOssFile: "OSS 檔案",
		colBytes: "位元組",
		colSource: "來源",
		colUploaded: "上傳時間",
		colFilename: "檔名",
		colReason: "原因",
		colMode: "影子",
		colDetail: "詳細",
		colOriginFileId: "原始檔案 ID",
		colReuseCount: "複用次數",
		colFirstSeen: "首次",
		colLastReuse: "最近複用",
		colUser: "使用者",
		colAuth: "認證",
		colOpened: "開始",
		colClosed: "結束",
		colUploads: "上傳數",
		colTotalBytes: "總位元組",
		colCloseReason: "關閉原因",
	},
	dbConfig: {
		title: "資料庫配置",
		step1: "選擇資料庫模型",
		step2: "選擇輸出形式",
		step3: "配置表單/文件",
		step4: "配置欄位",
		selectedOutput: "選定輸出形式",
		structuredForm: "結構化表單",
		structuredF1: "· 按照自訂的表單匯出資料",
		advFilter: "· 支援進階檢索",
		univariate: "· 支援單變量統計分析",
		crfExport: "· 根據資料生成CRF表格，可匯出PDF/Word文件",
		defaultForm: "預設表單",
		defaultF1: "· 按照預設結構顯示表單",
		formConfigTitle: "項目表單配置",
		formName: "項目表單名稱",
		formCode: "項目表單編碼",
		formOrder: "項目表單排序",
		visible: "是否顯示",
		formModelConfigTitle: "項目表單模型配置",
		selectModel: "選擇模型",
		newModel: "新增模型",
		colIndex: "序號",
		modelCode: "模型編碼",
		modelName: "模型名稱",
		modelDomain: "模型領域",
		modelOrder: "模型排序",
		modelConfigTitle: "項目模型配置",
		modelNameLabel: "項目模型名稱",
		modelCodeLabel: "*項目模型編碼",
		modelCodeLabelReq: "項目模型編碼",
		dontModify: "非必要情況請勿修改",
		deletionMode: "刪除方式",
		logical: "邏輯",
		physical: "物理",
		modelDescription: "模型描述",
		showNoteInput: "顯示註釋輸入框",
		note: "註釋",
		sceneType: "場景類型",
		sceneDefault: "預設場景",
		sceneTable: "表格場景",
		sceneTableDialog: "表格彈窗場景",
		sceneList: "列表場景",
		uploadAttachment: "上傳附件",
		on: "開",
		off: "關",
		saveModelAttrs: "儲存模型屬性",
		editFields: "編輯欄位",
		modelFieldConfigTitle: "項目模型欄位配置",
		previous: "上一步",
		next: "下一步",
		selectedInfo: "目前選定資訊",
		availableInfo: "可選資訊內容",
		codeFormatHint: "請輸入字母、數字或底線",
		selectRowFirst: "請選擇一筆資料後新增",
		enterModelName: "請輸入項目模型名稱",
		enterModelCode: "請輸入項目模型編碼",
		modelCodeFormat: "模型編碼只能包含字母、數字和底線",
		saveFormFirst: "請先儲存表單資訊",
		modelCodeExists: "該模型編碼已存在",
	},
	fieldList: {
		colFieldOrder: "欄位排序",
		colIntegrityScore: "完整度分",
		colFieldCode: "欄位編碼",
		colFieldName: "欄位名稱",
		colFieldType: "欄位類型",
		colVisible: "是否顯示",
		colEditable: "是否可編輯",
		colRequired: "是否必填",
		colDictValue: "字典值",
		addField: "新增欄位",
		refField: "引用欄位",
		dlgEdit: "編輯",
		dlgAdd: "新增",
		order: "排序",
		noSorting: "不排序",
		reservedHint: "以下欄位編碼具有特殊含義，會自動對應到病人資訊表：",
		colMeaning: "含義",
		colDescription: "說明",
		reservedUniqueNote: "其中 <b>card_id</b>、<b>inpatient_id</b>、<b>outpatient_id</b> 具有唯一性約束，同一項目內不允許重複值，可用於防止重複錄入病人。",
		fieldNameZh: "欄位中文名",
		fieldNameEn: "欄位英文名",
		fieldAlias: "欄位別名",
		tailLabel: "尾部標籤",
		refRange: "參考範圍",
		refMin: "下限",
		refMax: "上限",
		refRangeHint: "僅數值類型；越界時標記異常，不阻止保存",
		refRangeInvalid: "參考範圍下限不能大於上限",
		fieldDesc: "欄位解釋",
		controlsVisibility: "是否控制顯示",
		controlledFields: "受控欄位",
		optionCode: "選項編碼",
		optionName: "選項名稱",
		controlledFieldCount: "受控欄位數量",
		controlledModelCount: "受控模型數量",
		inFormEvent: "表單內事件",
		inModelEvent: "模型內事件",
		inModelClickEvent: "模型內click事件",
		showNoteInput: "顯示註釋輸入框",
		note: "註釋",
		subFieldList: "子欄位列表",
		refList: "引用列表",
		selectExisting: "選擇已有欄位",
		colIndex: "序號",
		colModifiedBy: "修改人",
		colModifiedAt: "修改時間",
		dlgSubEdit: "子欄位編輯",
		dlgSubAdd: "子欄位新增",
		existingFieldList: "已有欄位列表",
		fieldControlled: "欄位受控",
		modelControlled: "模型受控",
		colFieldId: "欄位ID",
		colModelId: "模型ID",
		colModelCode: "模型編碼",
		colModelName: "模型名稱",
		refSaved: "引用關係儲存成功",
		convertedToSub: "已修改為子欄位",
		none: "無",
		reserved: {
			name: { n: "姓名", d: "病人姓名" },
			gender: { n: "性別", d: "0=女, 1=男" },
			age: { n: "年齡", d: "病人年齡" },
			birthday: { n: "出生日期", d: "病人生日" },
			phone: { n: "手機號", d: "聯絡電話" },
			idNum: { n: "身份證號", d: "身份證號碼" },
			cardId: { n: "住院卡號", d: "唯一約束，不可重複" },
			inpatientId: { n: "門診號", d: "唯一約束，不可重複" },
			outpatientId: { n: "住院號", d: "唯一約束，不可重複" },
			admissionTime: { n: "入院時間", d: "日期類型" },
			enrollmentTime: { n: "入組時間", d: "日期類型" },
			diagnosis: { n: "診斷", d: "診斷資訊" },
			doctorId: { n: "醫生ID", d: "關聯醫生" },
			doctorName: { n: "醫生名字", d: "關聯醫生姓名" },
			hospitalName: { n: "所屬醫院", d: "醫院名稱" },
			status: { n: "病人狀態", d: "如：入組、出組" },
			statusCode: { n: "狀態編碼", d: "狀態對應編碼" },
		},
	},
	customColumn: {
		title: "設定自訂欄",
		searchFieldPh: "輸入檢索欄位的名稱",
		name: "名稱",
		order: "排序",
		visible: "是否顯示",
		description: "描述",
		propertyPath: "屬性路徑",
		selectProperty: "請選擇屬性",
		colIndex: "序號",
	},
	piiRule: {
		title: "PII 規則配置",
		currentProject: "目前項目",
		refresh: "重新整理",
		readonly: "只讀出口脫敏 (read-side anonymisation)",
		readonlyDesc: "規則僅在資料匯出與佇列檢索路徑上生效；落盤資料不變。預設 KEEP 表示原樣返回。具備 pii.unmask 權限的角色可繞過脫敏 (繞過會被記入審計)。",
		addRule: "新增規則",
		preview: "規則預覽",
		saveAll: "儲存全部修改",
		empty: "尚未配置任何 PII 規則",
		colField: "欄位編碼 (field_code)",
		colMode: "脫敏方式",
		colExample: "範例",
		colNote: "備註",
		colOperation: "操作",
		actDelete: "刪除",
		modeKeep: "保留原值 (預設)",
		modeMask: "掩碼",
		modeRedact: "佔位符替換",
		modePseudonym: "項目內確定性化名",
		modeHash: "SHA-256 雜湊 (12 hex)",
		modeSuppress: "完全刪除欄位",
		modeGeneralise: "分桶/分級泛化",
		previewMissingInput: "請填寫欄位與脫敏方式。",
		draftMissingFieldCode: "新增的規則必須填寫欄位編碼。",
		saveSummary: "已儲存 {saved} 條 · 刪除 {deleted} 條",
	},
	analytics: {
		overviewTitle: "分析概覽",
		datasetTitle: "資料集",
		encodingTitle: "欄位編碼",
		selectionTitle: "欄位篩選",
		algorithmTitle: "演算法執行",
		reportTitle: "統計報告",
		researchOverviewTitle: "分析概覽",
		libraryTitle: "研究資料",
		topicsTitle: "課題推薦",
		workbenchTitle: "分析工作台",
		refresh: "重新整理資料",
		empty: "暫無分析資料",
		statSamples: "樣本數",
		statFields: "欄位數",
		statAnalyses: "分析數",
		recentAnalyses: "最近分析",
		colName: "分析名稱",
		colType: "類型",
		colCreatedAt: "建立時間",
		colOperation: "操作",
		actView: "查看",
		viewDetail: "查看詳情",
		typeAlgorithm: "演算法執行",
		typeReport: "統計報告",
		errorProject: "項目資訊未找到",
		errorFetch: "取得資料失敗",
		topics: {
			rescoreBtn: "按最新數據重新評估",
			runDiscovery: "運行發現",
			rediscoverForce: "重新發現（忽略已處理）",
			searchPlaceholder: "搜尋選題...",
			sourceDocPlaceholder: "來源文檔",
			variantTypePlaceholder: "類型",
			variant: {
				guidanceExtraction: "指南提取",
				subgroup: "亞組分析",
				combination: "聯合治療",
				methodology: "方法學",
				validation: "驗證研究",
				novelAssociation: "新關聯",
				endpoint: "終點分析",
				uncategorised: "未分類",
			},
			status: {
				proposed: "待審核",
				approved: "已批准",
				rejected: "已拒絕",
				deferred: "已暫緩",
				exploredNull: "已探索·未見顯著",
			},
			foundTopics: "已發現 {n} 個新選題",
			initialising: "正在初始化...",
			recommendTitle: "數據就緒推薦",
			recommendSub: "已按本項目實際數據填充率評估，以下課題現有數據可支撐分析",
			dataReadyPct: "數據就緒 {n}%",
			retrospectiveFeasible: "回顧性可做",
			needProspective: "需前瞻數據",
			startResearch: "開始研究分析",
			emptyTopics: "暫無推薦課題",
			runTopicDiscovery: "運行課題發現",
			compositeScore: "綜合評分",
			scoreComposite: "綜合",
			feasibilityScore: "可行性評分",
			scoreFeasible: "可行",
			dataCompleteness: "數據完整度",
			scoreData: "數據",
			relevanceHigh: "高度相關",
			relevanceNormal: "相關",
			noRelatedLiterature: "未檢索到高度相關文獻",
			novelty: {
				wellCovered: "文獻高度重合",
				partiallyCovered: "已有類似研究",
				novel: "新穎性良好",
			},
			label: {
				studyDesign: "研究設計:",
				primaryEndpoint: "主要終點:",
				dataFeasibility: "數據可行性:",
				requiredFields: "所需欄位:",
				prospectiveNeeds: "需補充採集:",
				analysisPath: "分析路徑:",
				suggestedAngle: "建議差異化角度:",
				sourceDocs: "來源文檔:",
			},
			dataReadyFields: "數據就緒 {matched}/{total} 欄位",
			fieldMissingMark: "·缺",
			docCount: "{n} 篇文檔",
			downloadPdf: "下載PDF",
			docNotFound: "文檔未找到",
			viewSourceLink: "查看來源",
			docType: {
				guidance: "指南文獻",
				research: "研究文獻",
				clinicalTrial: "臨床試驗",
				reference: "參考文件",
			},
			approve: "批准",
			defer: "暫緩",
			reject: "拒絕",
			editAndApprove: "編輯後批准",
			editDialogTitle: "編輯課題",
			form: {
				titleCn: "課題標題",
				titleEn: "英文標題",
				studyDesign: "研究設計",
				primaryEndpoint: "主要終點",
				hypothesis: "研究假設",
				notes: "備註",
				notesPlaceholder: "附加研究備註",
			},
			saveAndApprove: "儲存並批准",
			fieldMatched: "已匹配數據庫欄位: {field}",
			fieldUnavailable: "數據庫暫無此欄位，需補充採集",
			fieldSample: "樣本: {n}",
			msg: {
				downloadFailed: "下載失敗",
				noProfile: "尚未生成數據畫像，請先在「研究資料 → 數據集」生成數據畫像",
				rescoreDone: "已按最新數據重新評估 {n} 個課題，其中 {ready} 個數據就緒",
				rescoreFailed: "重新評估失敗",
				approveFailed: "課題批准失敗，請稍後重試",
				projectNotFound: "項目資訊未找到",
				discoveryStarted: "課題發現已啟動",
				discoveryStartFailed: "啟動發現失敗",
				discoveryDone: "發現完成: {n} 個新選題",
				discoveryFailed: "發現失敗: {error}",
				unknownError: "未知錯誤",
				confirmReject: "確定拒絕此課題？",
				approved: "課題已批准，可點擊「開始研究分析」進入研究流程",
				rejected: "課題已拒絕",
				deferred: "課題已暫緩",
				editedApproved: "課題已編輯並批准，可點擊「開始研究分析」進入研究流程",
				sessionCreated: "已建立研究會話，正在進入分析工作台",
				sessionCreateFailed: "建立研究會話失敗",
			},
			design: {
				retrospectiveCohort: "回顧性隊列研究",
				prospectiveCohort: "前瞻性隊列研究",
				caseControl: "病例對照研究",
				crossSectional: "橫斷面研究",
				rct: "隨機對照試驗",
				metaAnalysis: "薈萃分析",
				survivalAnalysis: "生存分析",
				prognosticFactor: "預後因素分析",
				diagnosticAccuracy: "診斷準確性研究",
				registryStudy: "登記研究",
				caseSeries: "病例系列",
			},
			term: {
				crisisOccurrence: "肌無力危象發生率",
				crisisIncidence: "肌無力危象發生率",
				myasthenicCrisis: "肌無力危象",
				mgAdlTotal: "MG-ADL總分",
				qmgScore: "QMG評分",
				mgQol15rScore: "MG-QOL15r評分",
				mgfaClassification: "MGFA臨床分型",
				ossermanClassification: "Osserman分型",
				mse: "微小狀態(MSE)",
				mms: "微小表現狀態(MMS)",
				csr: "完全穩定緩解(CSR)",
				atFollowUp: "（隨訪時）",
				at12MonthFollowUp: "（12個月隨訪時）",
				baseline: "基線",
				duringFollowUp: "隨訪期間",
				duringDiseaseCourse: "病程中",
				achievementOf: "達到",
				associationBetween: "關聯：",
				neckMuscleStrength: "頸部肌力",
				thyroidFunction: "甲狀腺功能",
				autoantibody: "自身抗體",
				serumCreatinine: "血清肌酐",
				urea: "尿素",
				smoking: "吸煙",
				and: "與",
			},
		},
		library: {
			tabDataset: "資料集",
			tabGuidance: "指南文獻",
			tabResearch: "研究文獻",
			tabReference: "參考檔案",
			modeNew: "新資料集",
			modeVersion: "新版本",
			uploadDataset: "上傳資料集",
			generating: "生成中...",
			refreshProfile: "重新整理資料畫像",
			generateProfile: "生成資料畫像",
			clinicalDbPatients: "臨床資料庫 {n} 名患者",
			profileFieldCount: "畫像 {n} 欄位",
			profileTitle: "資料畫像",
			profileTag: "每欄位填充率 / 去重 / 分佈",
			profileHint: "分析按需從原始樹狀資料展開生成，本畫像用於研判課題資料可行性",
			multiRecordTag: "多記錄 · 分析時按需展開",
			colField: "欄位",
			colType: "類型",
			colFillRate: "填充率",
			colUniqueCount: "去重數",
			colDistribution: "分佈 / 樣例",
			emptyDatasets: "暫無資料集，點擊上方按鈕上傳",
			colDatasetName: "資料集名稱",
			colDatasetCode: "編碼",
			colSource: "來源",
			colLatestVersion: "最新版本",
			colHeaderRows: "標題行",
			colDescription: "描述",
			colUploadTime: "上傳時間",
			actVersions: "版本",
			actDownload: "下載",
			actRename: "重新命名",
			previewTitle: "資料預覽",
			previewBaseline: "基本資料 / 基線",
			previewBaselineCount: "{n} 名患者",
			previewFollowup: "隨訪記錄",
			previewFollowupCount: "{n} 條",
			emptyPreview: "暫無預覽資料",
			uploadNewDataset: "上傳新資料集",
			uploadNewVersion: "上傳新版本",
			fieldSelectDataset: "選擇資料集",
			placeholderSelectDataset: "選擇要更新的資料集",
			placeholderDatasetName: "如: 胃癌患者資料集",
			fieldDatasetCode: "資料集編碼",
			placeholderDatasetCode: "可選，留空自動產生",
			fieldHeaderRowCount: "標題行數量",
			fieldVersion: "版本號",
			placeholderVersionDesc: "版本描述（可選）",
			fieldDataFile: "資料檔案",
			dragOrClick: "拖曳檔案或",
			clickToUpload: "點擊上傳",
			tipDatasetFormats: "支援 .xlsx, .xls, .csv",
			uploading: "上傳中...",
			upload: "上傳",
			versionsTitle: "資料集版本",
			colVersion: "版本",
			colStatus: "狀態",
			tagCurrent: "目前",
			colRowCount: "行數",
			colColumnCount: "列數",
			colCreateTime: "建立時間",
			actActivate: "啟用",
			renameTitle: "重新命名資料集",
			placeholderDescriptionOptional: "描述（可選）",
			profileDone: "資料畫像已生成",
			profileDoneDetail: "共 {n} 個欄位的填充率與分佈已統計完成",
			generateFailed: "生成失敗",
			uploadReference: "上傳參考檔案",
			referenceHint: "上傳研究中需要參考的各類檔案",
			emptyReference: "暫無參考檔案",
			colFileName: "檔案名稱",
			colFileSize: "檔案大小",
			placeholderFileDesc: "檔案描述（可選）",
			fieldFile: "檔案",
			maxFiles5: "（最多5個）",
			uploadGuidance: "上傳指南文獻",
			extracting: "提取中...",
			extractTopics: "提取研究選題",
			guidanceHint: "上傳醫學指南 PDF，再點「提取研究選題」由 AI 生成研究方向",
			emptyGuidance: "暫無指南文獻，點擊上方按鈕上傳醫學指南 PDF",
			colTitle: "標題",
			colRelevance: "相關度",
			colTopics: "選題",
			topicsExtracted: "已提取 {n}",
			statusFailed: "失敗",
			statusPending: "待提取",
			placeholderBatchDesc: "批次描述（可選，套用至本次上傳的所有檔案）",
			maxFiles20: "（可多選，最多20個）",
			tipGuidanceFormats: "支援 .pdf 檔案；同名檔案已存在時會跳過",
			resultOk: "成功",
			resultSkipped: "跳過",
			extractDone: "提取完成",
			extractFailed: "提取失敗",
			searching: "搜尋中...",
			searchPubmed: "從PubMed搜尋",
			searchCT: "從ClinicalTrials.gov搜尋",
			researchHint: "基於項目ICD10編碼搜尋治療效果相關的研究文獻和臨床試驗",
			pubmedSearchDone: "PubMed搜尋完成:",
			pubmedSearchFailed: "PubMed搜尋失敗:",
			ctSearchDone: "ClinicalTrials搜尋完成:",
			ctSearchFailed: "ClinicalTrials搜尋失敗:",
			emptyResearch: "暫無研究文獻，點擊上方按鈕從PubMed或ClinicalTrials.gov搜尋",
			colJournalStatus: "期刊/狀態",
			colPubDate: "發表日期",
			actLink: "連結",
			fieldCount: "數量",
			start: "開始",
			startSearch: "開始搜尋",
			typeNumber: "數值",
			typeString: "文字",
			typeDate: "日期",
			typeSingleSelect: "單選",
			typeMultiSelect: "多選",
			avgSelections: "平均選 {n} 項",
			numericRange: "{min}–{max}（均 {mean}）",
			sourceUpload: "上傳",
			sourceResearch: "研究產出",
			sourceDbImportLegacy: "資料庫匯入(舊)",
			sourceDatabase: "資料庫",
			sourceAiFilter: "智能篩選",
			msgNewDatasetUploaded: "新資料集上傳成功",
			msgNewVersionUploaded: "新版本上傳成功",
			msgUploadFailed: "上傳失敗",
			msgColumnMismatch: "欄位定義與之前版本不相符，請確保資料結構一致",
			msgPreviewFailed: "載入預覽資料失敗",
			msgVersionsFailed: "取得版本資料失敗",
			msgRenameSuccess: "重新命名成功",
			msgRenameFailed: "重新命名失敗",
			confirmDeleteDataset: "確定刪除資料集「{name}」？此操作將同時刪除所有版本。",
			confirmDeleteTitle: "確認刪除",
			msgDatasetDeleted: "資料集已刪除",
			msgDeleteFailed: "刪除失敗",
			msgDownloadFailed: "下載失敗",
			msgVersionActivated: "版本已啟用",
			msgActivateFailed: "啟用失敗",
			confirmDeleteVersion: "確定刪除版本 {version}？",
			msgVersionDeleted: "版本已刪除",
			confirmGenerateProfile: "將掃描臨床資料庫中 {n} 名患者的全部病歷，統計每個欄位的資料畫像（填充率、去重數、取值分佈），用於研判\"哪些課題我們已有資料\"。此操作可能需要幾分鐘。",
			msgProfileStartFailed: "啟動生成失敗",
			msgInitializing: "正在初始化...",
			msgProcessing: "處理中...",
			msgRefUploaded: "參考檔案上傳成功",
			confirmDeleteFile: "確定刪除檔案「{name}」？",
			uploadProgress: "正在上傳 ({current}/{total})",
			msgFilesUploaded: "成功上傳 {n} 個檔案",
			msgFilesSkipped: "，{n} 個跳過",
			msgNoFileUploaded: "沒有檔案上傳成功",
			confirmDeleteNamed: "確定刪除「{name}」？",
			msgExtractAlreadyRunning: "提取任務已在執行中...",
			msgExtractStartFailed: "啟動提取失敗",
			extractSummary: "處理 {processed} 篇，提取 {topics} 個選題",
			extractSkipped: "，跳過 {n} 篇",
			crawlPubmedTitle: "搜尋PubMed研究文獻",
			crawlPubmedMessage: "將基於項目ICD10編碼，從PubMed搜尋治療效果相關的研究文獻。",
			msgPubmedStarted: "PubMed搜尋已啟動，可繼續操作",
			msgSearchAlreadyRunning: "搜尋任務已在執行中...",
			msgSearchStartFailed: "啟動搜尋失敗",
			researchSummary: "取得 {downloaded} 篇，跳過 {skipped} 篇",
			researchFailedCount: "，失敗 {n} 篇",
			msgSearchFailed: "搜尋失敗",
			crawlCtTitle: "搜尋ClinicalTrials.gov臨床試驗",
			crawlCtMessage: "將基於項目ICD10編碼，從ClinicalTrials.gov搜尋相關的臨床試驗。",
			msgCtStarted: "ClinicalTrials搜尋已啟動，可繼續操作",
			ctSummary: "取得 {downloaded} 個，跳過 {skipped} 個",
			ctFailedCount: "，失敗 {n} 個",
			docTitleWithFile: "{desc}（{file}）",
		},
		researchHome: {
			noDisease: "未設定疾病",
			noObjective: "未設定研究目標",
			activeResearch: "進行中的研究",
			viewAll: "查看全部",
			continueAnalysis: "繼續分析",
			recommendedTopics: "推薦課題（資料就緒）",
			dataReadyPct: "資料就緒 {n}%",
			treatmentInsights: "治療洞察",
			exploring: "探索進行中",
			exploreNow: "立即探索",
			autopilotAlertWithTopic: "自動探索進行中：正在分析「{title}」— 約需 1–3 小時，期間可離開此頁",
			autopilotAlert: "自動探索進行中 — 約需 1–3 小時，完成的研究與洞察將自動出現，期間可離開此頁",
			noInsights: "暫無治療洞察 — 研究完成後將自動提煉關鍵發現",
			pickDataReadyTopic: "挑選資料就緒課題",
			openWorkbench: "進入分析工作台",
			researchRecords: "研究記錄",
			colTitle: "研究題目",
			colStatus: "狀態",
			colCohort: "隊列",
			colInsights: "洞察",
			colUpdatedAt: "更新時間",
			noResearch: "暫無研究 — 從資料就緒課題一鍵開始",
			projectSettings: "項目設定",
			diseaseName: "疾病名稱",
			diseasePlaceholder: "如: 胃癌",
			icd10Codes: "ICD-10編碼",
			icd10Placeholder: "輸入編碼後按 Enter 新增",
			researchObjective: "研究目標",
			objectivePlaceholder: "描述本項目的整體研究方向和目標",
			autopilot: "自動探索",
			intervalPrefix: "每",
			intervalSuffix: "天自動執行一次",
			autopilotOffHint: "關閉後仍可在課題頁手動發起分析",
			autopilotHint: "每次執行自動發現課題並完成一項統計分析（約 1–3 小時推理算力）；到期後於凌晨 3 點啟動。",
			statDocuments: "研究文檔",
			statTopics: "推薦課題",
			statAnalyses: "分析任務",
			subDataReady: "{n} 個資料就緒",
			subActive: "{n} 個進行中",
			subFindings: "{n} 條發現",
			autopilotDone: "自動探索已完成",
			autopilotConfirmMsg: "將自動發現研究課題並逐個嘗試統計分析——不顯著就換下一個方向，直到產出有統計學意義的發現或候選課題用盡。可能執行數小時並消耗較多推理算力。是否現在開始？",
			startExplore: "開始探索",
			autopilotAlreadyRunning: "自動探索已在進行中",
			autopilotStarted: "自動探索已啟動，完成後新的研究與洞察將自動出現",
			autopilotStartFailed: "啟動自動探索失敗",
			settingsSaved: "設定已儲存",
			settingsSaveFailed: "儲存設定失敗",
			status: {
				active: "進行中",
				completed: "已完成",
				failed: "失敗",
				archived: "已歸檔",
			},
		},
		workbench: {
			title: "科研分析工作台",
			backToList: "返回列表",
			archivedTitle: "未見顯著探索",
			archivedToggle: "未見顯著探索 ({n})",
			refresh: "重新整理",
			newStudy: "新建研究",
			emptyArchived: "暫無未見顯著的自動探索",
			emptySessions: "暫無研究分析會話",
			createFirst: "建立第一個研究",
			colTitle: "研究題目",
			tagAuto: "自動",
			colStage: "當前階段",
			colStatus: "狀態",
			colCohort: "隊列",
			colInsights: "洞察",
			colUpdated: "更新時間",
			colActions: "操作",
			open: "開啟",
			startOver: "重新開始",
			tabPipeline: "流程",
			viewingConfirmedStage: "正在查看已確認的歷史環節（唯讀）。點擊「{stage}」可回到當前環節。",
			interpretDisabledHint: "完成統計分析後可用",
			tabInterpret: "解讀與探索",
			createTitle: "新建研究分析",
			labelHypothesis: "研究假設",
			hypothesisPlaceholder: "例如：超適應症與適應症支架治療 sICAS 的安全性與中長期結局差異",
			labelMode: "運行方式",
			modeAuto: "自動探索（推薦）",
			modeManual: "逐步確認",
			modeAutoHint: "全程自動跑完；若無統計學意義的結果會自動更換策略重試（最多 8 輪）。全程可即時觀看，隨時暫停、指導或停止。",
			modeManualHint: "每個環節由您確認後再繼續（原有流程）。",
			labelCohort: "研究隊列",
			cohortFromFilter: "來自 AI 進階篩選",
			cohortPaste: "貼上患者編號",
			cohortLater: "稍後綁定",
			labelConversation: "篩選會話",
			conversationPlaceholder: "選擇已儲存的 AI 篩選會話",
			labelPatientIds: "患者編號",
			patientIdsPlaceholder: "以逗號、空格或換行分隔的 patient_no",
			create: "建立",
			cohortBlockedReason: "請先在下方選擇研究人群並點擊「綁定隊列」；如確需全項目分析，請選擇「使用全項目患者」後綁定。",
			restartConfirm: "從第 1 步重做本研究？研究卡片、隊列、變數映射、統計結果與既有解讀都會清空；研究選題、假設與已上傳的指南保留，並可重新選擇研究人群。",
			deleteConfirm: "確定刪除「{name}」？刪除後無法復原。",
			deleteTitle: "確認刪除",
			status: {
				active: "進行中",
				completed: "已完成",
				failed: "失敗",
				abandoned: "已放棄",
			},
			msg: {
				openFailed: "開啟會話失敗",
				noProject: "未取得當前項目",
				selectConversation: "請選擇篩選會話",
				pastePatientIds: "請貼上至少一個患者編號",
				createFailed: "建立會話失敗",
				restarted: "已重設，請重新起草研究卡片",
				deleted: "已刪除",
				confirmFailed: "確認失敗",
				rejectFailed: "退回失敗",
			},
		},
		inbox: {
			title: "治療回顧",
			unreadCount: "{n} 未讀",
			markAllRead: "全部標為已讀",
			refresh: "重新整理",
			emptyDesc: "暫無治療回顧 — 平台將隨資料積累自動生成分析發現並在此推送",
			viewTopics: "查看課題推薦",
			loadFailed: "載入治療回顧失敗",
			markedAllRead: "已全部標為已讀",
		},
		insightCard: {
			sourceAnalysisTask: "來源：分析任務",
			autoDiscovered: "自動發現",
			effectSize: "效應量",
			type: {
				treatmentEfficacy: "治療對比",
				biomarker: "生物標誌物",
				survival: "生存分析",
				composite: "綜合分析",
				descriptive: "資料概覽",
				autoSchema: "智能發現",
			},
		},
		studyInsight: {
			autoDiscovered: "自動發現",
			pendingTooltip: "報告主要結論含臨床價值判斷，待醫生在報告「作者補充事項」中確認",
			pendingTag: "待確認",
			patternTag: "模式",
			patternTooltip: "臨床實踐模式探查：描述診療實踐本身（做了什麼、誰被選擇做了什麼、怎麼變的），未做療效比較，不可作因果解讀",
			findingCount: "{n} 條發現",
			status: {
				active: "進行中",
				completed: "已完成",
				failed: "失敗",
				abandoned: "已放棄",
			},
		},
		pipe: {
			interpret: {
				title: "解讀與探索",
				regenerateReport: "重新生成報告",
				generateReport: "生成報告",
				bundle: "完整分析包",
				evidenceHint: "報告引用文獻均來自平台檢索並核驗的證據包（共 {n} 篇）。",
				roundLabel: "第 {n} 輪探索",
				tagNeedsReflatten: "需重新展平",
				tagProposed: "待確認",
				tagDone: "已重跑",
				reflattenTitle: "該調整需重新展平資料（新建研究會話）",
				proposedChanges: "擬調整項",
				confirmRerun: "確認並重跑",
				keyEffects: "關鍵效應量",
				conclusion: "結論解讀",
				caveatsLabel: "統計學注意事項",
				limitationsLabel: "研究局限",
				noInterpretation: "尚未生成解讀。",
				generateInterpretation: "生成解讀",
				stop: "停止",
				elapsed: "已用時",
				stepLabel: "第 {n} 步",
				methodSuggestions: "方法建議",
				inputPlaceholder: "提出調整方向：更換協變量、加亞組、改匹配卡鉗、去掉某個終點…（Ctrl+Enter 發送）",
				inputHint: "統計有效性由智能體保證，臨床相關性由您把關。",
				send: "發送",
				working: "處理中…",
				model: {
					logistic: "Logistic 迴歸",
					cox: "Cox 生存分析",
					linear: "線性迴歸",
					geeLogistic: "GEE（隨訪級）",
					clusterLogistic: "聚類穩健 Logistic",
					coxTv: "時變 Cox",
					aipw: "AIPW 雙穩健（風險差）",
				},
				diff: {
					groupColumn: "分組變量",
					positiveGroup: "暴露組",
					referenceGroup: "參照組",
					covariates: "校正變量",
					tableOne: "基線表變量",
					matching: "傾向評分匹配",
					iptw: "IPTW 加權",
					models: "統計模型",
					roc: "ROC 分析",
					longitudinal: "各時點比較",
					competingRisks: "競爭風險分析",
					subgroups: "亞組分析",
					subgroupEndpoint: "亞組終點",
					analysisUnit: "分析單位",
					clusterColumn: "聚類變量",
					seed: "隨機種子",
				},
				diffVal: {
					removed: "（取消）",
					matchingOff: "不做匹配",
					caliper: "卡鉗 {v}",
					psOn: "按 {cols}",
					iptwStabilized: "穩定化權重",
					iptwUnstabilized: "非穩定化權重",
					none: "取消",
				},
				msg: {
					figuresLoadFailed: "圖表載入失敗——登入可能已過期，請重新整理頁面重新登入後再開啟本研究。",
				},
				chipAddText: "請加做「{name}」（{hook}），依據：{reason}。",
				chipMethodText: "請補充「{name}」（{hook}）。",
			},
			loop: {
				autoExplore: "自動探索",
				iterationCount: "第 {n}/{total} 輪",
				pause: "暫停",
				resume: "繼續",
				stopKeepBest: "停止並採用當前最優",
				continueExploring: "繼續探索",
				baselineEvaluation: "基線評估",
				running: "進行中…",
				startingFirst: "正在啟動第一輪探索…",
				methodLadder: "方法階梯",
				guidePlaceholder: "給下一輪策略的指導意見（可選）：如「試試以隨訪日期為時間零點」「分組改按有無手術記錄」…（Ctrl+Enter 發送）",
				guideHint: "探索不會因此中斷；這段話會在 AI 制定下一輪策略時被採納。",
				queuedCount: "已排隊 {n} 條",
				sendGuide: "發送指導",
				ladderInUse: "已在用：{items}",
				ladderNext: "建議下一步：{items}",
				ladderSparseEvents: "事件不足——先換終點/人群，不換方法",
				axesChanged: "改動：{names}",
				msg: {
					guideQueued: "已排隊，將在下一輪策略中採納",
					guideFailed: "發送失敗",
				},
				stopConfirmText: "停止自動探索？將保留當前最優結果並生成報告（探索過程保留在此時間線，不進入報告）；之後仍可點「繼續探索」追加輪次。",
				stopConfirmTitle: "停止探索",
				stop: "停止",
			},
			results: {
				sectionEndpointRates: "終點事件率",
				sectionEffectEstimates: "效應量估計（校正 / IPTW / 匹配）",
				sectionSurvival: "生存分析（log-rank）",
				sectionRoc: "診斷/判別價值（ROC）",
				sectionTimepoints: "各時點比較",
				sectionTableOneSingle: "表一 —— 全隊列描述",
				sectionTableOneBalance: "表一 —— 基線均衡性",
				sectionMatching: "傾向評分匹配 / IPTW",
				sectionCompetingRisks: "競爭風險分析（Aalen–Johansen 累計發生率 + 病因別 Cox）",
				sectionEvalue: "未測混雜敏感性（E 值）",
				sectionSubgroups: "亞組分析",
				sectionFigures: "統計圖",
				col: {
					endpoint: "終點",
					evaluable: "可評估",
					events: "事件",
					byGroupRate: "分組事件率",
					model: "模型",
					estimate: "估計值",
					estimateShort: "估計",
					variants: "各法估計",
					assumptions: "模型診斷",
					byGroupSurvival: "分組（n / 事件 / 中位天數）",
					cutoff: "界值",
					sens: "靈敏度",
					spec: "特異度",
					acc: "準確率",
					timepoint: "時點",
					test: "檢驗",
					pAdj: "P(校正)",
					variable: "變量",
					overall: "描述",
					analysis: "分析",
					causeSpecificHr: "病因別 HR (95%CI)",
					competingCauseHr: "競爭事件 HR",
					cif: "累計發生率（時點）",
					effect: "效應",
					rrApprox: "近似 RR（換算）",
					evalue: "E值",
					evalueCi: "E值（CI 界）",
					level: "亞組",
				},
				delongCi: "DeLong 95%CI",
				holmAdjusted: "（Holm 校正）",
				interactionP: "交互作用 P",
				evalueHint: "要完全解釋掉當前效應，未測混雜需同時與暴露、結局達到的最小關聯強度（RR 尺度）——E 值越大結論越穩健。",
				matching: {
					method: "方法",
					matchedPairs: "匹配對數",
					seed: "隨機種子",
					treatedControl: "暴露 / 對照",
					maxSmdBefore: "匹配前最大SMD",
					maxSmdAfter: "匹配後/加權後最大SMD",
					weighting: "加權方式",
					weightAto: "重疊加權（ATO，均衡人群）",
					weightIptw: "穩定化 IPTW",
					ess: "加權有效樣本量",
					essRatio: "（{pct}%）",
					commonSupport: "PS 共同支撐",
				},
				status: {
					insufficientEvents: "事件數不足",
					insufficientData: "數據不足",
					nonNumericEndpoint: "終點非數值",
					noOutcomeVariance: "結局無差異",
					columnsAbsent: "缺少欄位",
					endpointAbsent: "無此終點",
					unstable: "擬合不穩定",
					missingTimeEventColumns: "缺時間/事件欄位",
					insufficient: "樣本不足",
					failed: "失敗",
					fitFailed: "擬合失敗",
				},
				refGroup: "對照組",
				posGroup: "暴露組",
				diag: {
					epvText: "每變量事件數：{events} 事件 / {parameters} 個參數（閾值 {threshold}）",
					ph: "比例風險",
					phHolds: "比例風險假定成立（Schoenfeld 殘差 P≥0.05）",
					phViolated: "以下協變量違反比例風險假定：{vars}",
					normality: "殘差正態",
					equalVar: "方差齊性",
					separation: "疑似分離",
					separationText: "置信區間跨度異常，提示準完全分離，具體數值不可解釋",
				},
				listSep: "、",
				sepSemi: "；",
				variantStandardizedRd: "標準化風險差",
				variantBayesian: "貝葉斯後驗",
				pDirection: "P(方向)",
				numericDesc: "{mean} ± {sd}；中位數 {median} ({q1}–{q3})，n={n}",
				rrApproxText: "{rr}（{conversion}）",
			},
			stage: {
				round: "第 {n} 輪",
				roundShort: "第{n}輪",
				confirmPlan: "確認方案",
				submitRevision: "提交修改意見",
				redraft: "重新起草",
				regenerate: "重新生成",
				latestFeedback: "上輪修改意見（第{n}輪）",
				earlierFeedback: "更早的修改意見（{n}條）",
				working: "正在運行…",
				elapsed: "已用時",
				step: "第 {n} 步",
				longHint: "起草時間較長屬正常：AI 會先通讀本項目的欄位字典再落筆。您可以離開本頁，該步驟會繼續在後台運行。",
				executionLog: "執行日誌（{n} 條）",
				revisionFeedback: "修改意見",
				revisePlaceholder: "用一句話說明想怎麼改：如「終點改為30天再治療」「協變量加入糖尿病史」…（Ctrl+Enter 提交）",
				reviseHint: "AI 將按您的意見重寫草案，重寫後仍需您確認才會生效。",
				nothingProposed: "尚無提案",
				pickLine: "關於「{question}」：採用「{label}」",
				regenConfirmMsg: "放棄本輪草案並重新起草？",
				status: {
					proposed: "待確認",
					confirmed: "已確認",
					rejected: "已退回",
					error: "出錯",
					pending: "待運行",
				},
			},
			decision: {
				title: "關鍵決策點",
				recommended: "推薦",
				applyHint: "此選擇將隨「提交修改意見」由 AI 重寫草案後生效。",
			},
			effect: {
				colEndpoint: "終點",
				colModel: "模型",
				colEffect: "效應量 (95%CI)",
				tooFewEvents: "—（事件過少）",
				colEvents: "事件",
			},
			verify: {
				titleFail: "敘述審校未通過 —— 以下問題解決前，本研究不會推送到治療回顧",
				titleWarn: "敘述審校：存在提示項",
				sevContradiction: "矛盾",
				sevNote: "提示",
				reviewTitle: "多視角審稿",
				statRounds: "輪次",
				statIssues: "意見",
				statFixed: "已修訂",
				statToAuthor: "待作者",
				statDropped: "已駁回",
				tagBlocker: "阻斷",
				tagAuthor: "待作者",
				claimTitle: "主張核驗",
				primaryUnresolved: "主要結論待醫生確認",
				primary: "主要結論",
				hint: "所有數字均由平台計算，只有 AI 撰寫的敘述可能與之不符。重新生成解讀或報告即可重新審校。",
				claimSupported: "有支持",
				claimPartiallySupported: "部分支持",
				claimUnsupported: "無支持",
				claimContradicted: "相矛盾",
				claimNeedsConfirmation: "待醫生確認",
				quoted: "「{text}」",
			},
			stepper: {
				study_intake: "研究卡片",
				cohort_confirm: "隊列確認",
				variable_mapping: "變量映射",
				flatten_preview: "數據展平",
				encoding_exclusion: "編碼與排除",
				analysis: "統計分析",
				report_export: "報告與匯出",
			},
			body: {
				study: {
					disease: "疾病",
					hypothesis: "研究假設",
					design: "研究設計",
					groupingVariable: "分組變量",
					onLabel: "適應症",
					offLabel: "超適應症",
					endpoints: "研究終點",
					covariates: "協變量",
				},
				cohort: {
					source: "來源",
					matched: "命中例數",
					filterConversation: "篩選會話",
					querySummary: "篩選說明",
					samplePatients: "樣例患者：",
					unboundWarning: "尚未綁定隊列 —— 將分析全項目全部患者。",
					unboundPickWarning: "尚未綁定隊列 —— 直接確認將分析全項目全部患者。請在下方選擇研究人群。",
					changeCohort: "更換隊列",
					modeConversation: "來自 AI 高級篩選",
					modeManual: "貼上患者編號",
					modeAll: "使用全項目患者",
					selectConversationPlaceholder: "選擇已儲存的 AI 篩選會話",
					matchedCountSuffix: "（{n} 例）",
					noConversations: "暫無已儲存的 AI 篩選會話 —— 可到 數據管理 → 高級篩選 → AI篩選 構建隊列後返回。",
					pastePlaceholder: "以逗號、空格或換行分隔的 patient_no",
					allNote: "明確選擇分析本項目全部患者（不作人群限定）。",
					bindCohort: "綁定隊列",
					msg: {
						selectConversation: "請選擇篩選會話",
						pasteAtLeastOne: "請輸入至少一個患者編號",
						wholeProjectSelected: "已選擇全項目患者",
						cohortBound: "已綁定隊列：{n} 例",
						bindFailed: "綁定隊列失敗",
					},
				},
				variables: {
					endpointCount: "{n} 個終點",
					groupCount: "{n} 個分組",
					visitLevel: "隨訪級分析",
					studyGroups: "研究分組",
					presenceRule: "有「{field}」記錄即為{pos}，沒有則為{neg}",
					cutAt: "按 {cuts} 分組",
					quantileRule: "按隊列分位數 {cuts} 切分（切點在展平時按實際隊列求出）",
					endpoints: "研究終點",
					survival: "生存分析",
					positiveValue: "取值為「{v}」時計為發生",
					dataIncluded: "納入的資料",
					allDataKept: "保留全部模型與欄位；同一患者的多次記錄按欄位類型自動匯總（數值取均值、日期取最早、其餘合併）。",
					noSpecTitle: "尚未定義分組變量與研究終點",
					noSpecDesc: "現在確認將只能做描述性統計。如需組間比較，請在下方「修改意見」裡說明分組與終點口徑，或點「重新起草」。",
					allModels: "全部模型",
					modelCount: "{n} 個模型",
					dayRange: "第 {lo}–{hi} 天",
					atDay: "第 {d} 天",
					atDayTol: "第 {d} 天（{tol} 天內取最近）",
					sustained: "持續 ≥{d} 天",
					binarize: "{rule} 記為事件",
				},
				flatten: {
					patientRows: "患者表行數",
					visitRows: "隨訪表行數",
					analysisRows: "分析表行數",
					codebookCols: "編碼表列數",
					deriveSummary: "派生變量概覽",
					colKey: "項目",
					colValue: "值",
					previewTitle: "數據預覽（前若干行）",
					tabPatient: "患者表",
					tabVisit: "隨訪表",
					tabAnalysis: "分析表",
				},
				encoding: {
					exclusionRules: "排除規則",
					keep: "保留：",
					variableEncoding: "變量編碼",
					colVariable: "變量",
					colPositive: "陽性值",
					missingPolicy: "缺失處理策略",
				},
				analysis: {
					analysisN: "分析樣本",
					groups: "分組",
					grouping: "分組變量",
					covariates: "協變量",
					matching: "匹配",
					models: "模型",
					methodCheck: "方法核對",
					applicable: "可用",
					suggested: "項升級建議",
					inUse: "已在用",
					alsoApplicable: "亦可用",
					notFeasible: "不可行",
					roadmap: "進階方向",
					roadmapHint: "{trigger}（平台暫不支援）",
					results: "統計結果",
				},
				report: {
					title: "題目",
					design: "設計",
					cohort: "隊列例數",
					analysisN: "分析樣本",
					groups: "分組",
					keyFindings: "主要結果",
					colEndpoint: "終點",
					colModel: "模型",
					colEffect: "效應量 (95%CI)",
					downloads: "下載",
					rebuildTables: "重建數據表",
					pendingAuthor: "待作者確認 {n} 項（見報告「作者補充事項」）",
					completedNote: "流程已完成。可重現分析包重跑得到逐位元組一致的 results.json。",
					rebuildOk: "數據表已重建：分析表 {n} 行",
					rebuildFailed: "重建失敗，請稍後重試",
					downloadFailed: "該檔案尚未生成或下載失敗",
					dl: {
						bundle: "完整分析包",
						strobeDocx: "研究報告 (Word)",
						script: "可重現腳本",
						scriptR: "R 腳本",
						results: "結果 JSON",
						analysisCsv: "分析表",
						patientCsv: "患者表",
						visitCsv: "隨訪表",
						codebook: "編碼表",
					},
				},
			},
			hooks: {
				loopReconnecting: "連接中斷，正在重新接入自動探索…",
				processFailed: "處理失敗",
				explorationDisconnected: "與伺服器的連接已中斷，該任務已停止。請重新整理頁面後再試。",
				advanceDisconnected: "與伺服器的連接已中斷，本步驟可能已停止。請重新整理頁面：若仍在執行會自動重新接入，否則可重新執行該步驟。",
				durationMinSec: "{m} 分 {s} 秒",
				durationSec: "{s} 秒",
			},
		},
		dataset: {
			modeNew: "新資料集",
			modeVersion: "新版本",
			selectDataset: "選擇資料集",
			selectDatasetPlaceholder: "選擇要更新的資料集",
			datasetName: "資料集名稱",
			datasetCodeOptional: "資料集編碼（可選）",
			autoGenerateHint: "如留空將自動產生",
			version: "版本",
			versionHint: "建議版本號，您可以根據需要進行修改",
			headerRowCount: "標題行數量",
			headerRowCountHint: "指定資料檔案中的標題行數量 (1-10)",
			datasetDescription: "資料集描述",
			datasetFile: "資料集檔案",
			selectFile: "選擇檔案",
			acceptHint: "支援副檔名：.xlsx, .xls, .csv",
			uploading: "正在上傳...",
			uploadNewDataset: "上傳新資料集",
			uploadNewVersion: "上傳新版本",
			manageTitle: "資料集管理",
			datasetCode: "資料集編碼",
			latestVersion: "最新版本",
			versionDescription: "版本描述",
			uploadTime: "上傳時間",
			versionHistory: "歷史版本",
			viewVersions: "查看版本",
			versionsDialogTitle: "資料集版本",
			createdAt: "建立時間",
			description: "描述",
			msgSelectFile: "請選擇檔案",
			msgSelectDatasetToUpdate: "請選擇要更新的資料集",
			msgDatasetNotFound: "無法找到選定資料集的詳細資訊。請重新整理列表或重試。",
			msgUploadNewSuccess: "新資料集上傳成功",
			msgUploadVersionSuccess: "資料集 {name} 的新版本 {version} 上傳成功",
			msgUploadError: "上傳資料集時出錯",
			msgColumnMismatch: "無法上傳新版本：欄位定義與之前的版本不相符。請確保資料結構一致。",
			msgFileInvalid: "無法處理檔案：檔案格式無效或損毀。請確保檔案是有效的 CSV 或 Excel 檔案。",
			msgLoadDatasetsFailed: "載入資料集失敗",
			msgLoadVersionsFailed: "載入資料集版本失敗",
		},
		nav: {
			title: "資料分析工具",
			overview: "分析概覽",
			dataset: "資料集",
			encoding: "欄位編碼",
			selection: "欄位篩選",
			algorithm: "演算法執行",
			report: "統計報告",
		},
		encoding: {
			saveConfig: "儲存配置",
			exportProcessedData: "匯出處理數據",
			selectDatasetLabel: "選擇要處理的數據集",
			selectDatasetPlaceholder: "選擇數據集",
			noDatasetsForProject: "未找到該項目的數據集，請先上載數據集。",
			tabMetadata: "1. 欄位分類",
			datasetLabel: "數據集",
			rescanMetadata: "重新掃描元數據",
			dataTypeDetails: "數據類型詳情",
			numericStats: "數值型: 最小值: {min}, 最大值: {max}, 平均值: {mean}, 中位數: {median}, 標準差: {std}",
			categoricalStats: "分類型: 類別: {categories} (有序: {ordered})",
			nullFrequency: "空值頻率",
			uniqueCount: "唯一值數量",
			dataQuality: "數據質量",
			colColumnName: "欄位名稱",
			colDataType: "數據類型",
			colNullable: "可為空",
			colUnique: "是否唯一",
			goToImputation: "進入缺失值填補",
			tabImputation: "2. 缺失值填補",
			noColumnsForImputation: "沒有可用於填補的欄位。",
			imputationTip: "可以為任意欄位設定填補策略，即使該欄位沒有缺失值。這對於處理未來可能出現的缺失值很有幫助。",
			fieldStatistics: "欄位統計資訊",
			colMissingBefore: "填補前缺失率",
			colImputationStrategy: "填補策略",
			selectStrategy: "選擇策略",
			colParameters: "參數",
			paramTypeTodo: "參數類型 '{type}' 待配置",
			noParameters: "無參數",
			colMissingAfter: "填補後缺失率",
			helpLabel: "幫助",
			imputationHelp: "數值型數據可用均值/中位數填補；分類數據可用眾數填補。時間序列數據可用前值填充法（LOCF）。請考慮臨床應用的實際意義。",
			backToMetadata: "返回元數據",
			resetToDefault: "重設為預設",
			applyImputationContinue: "應用填補並繼續",
			tabEncoding: "3. 編碼策略",
			outputColumnStatistics: "編碼輸出欄位統計資訊",
			dataLoading: "數據載入中...",
			colEncodingStrategy: "編碼策略",
			colOutputPreview: "輸出欄位預覽",
			infoLossWarning: "選定的編碼策略可能會導致資訊遺失（例如，丟棄類別）。",
			backToImputation: "返回填補",
			applyEncodingSave: "應用編碼並儲存",
			dataPreviewTitle: "數據預覽（樣本）",
			refreshPreview: "刷新預覽",
			auditLogTitle: "轉換審計日誌",
			noAuditRecords: "暫無轉換記錄。",
			dataPreview: "數據預覽",
			auditLog: "審計日誌",
			paramEnter: "輸入 {name}",
			paramBasedOnType: " (基於欄位類型: {type})",
			paramDefault: ", 預設: {value}",
			paramTupleExample: "例如 (0, 1), 預設: {value}",
			paramCommaList: "逗號分隔列表, 預設: {value}",
			msgNoDatasets: "未找到數據集",
			msgFetchDatasetsFailed: "獲取數據集列表失敗",
			msgLoadDatasetMetadataFailed: "載入數據集元數據失敗",
			auditLoadMetadata: "載入元數據",
			auditLoadMetadataDetail: "已載入 {n} 個欄位的元數據",
			msgNoColumnMetadata: "未找到欄位元數據",
			msgFetchColumnMetadataFailed: "獲取欄位元數據失敗",
			msgRescanComplete: "元數據重新掃描完成",
			msgRescanFailed: "重新掃描元數據失敗",
			msgResetImputationSuccess: "已重設為預設填補策略",
			msgResetImputationFailed: "重設為預設填補策略失敗",
			msgFetchImputationFailed: "獲取填補策略失敗",
			msgFetchEncodingFailed: "獲取編碼策略失敗",
			columnCount: "({n} 欄)",
			msgEncodingSaved: "編碼策略儲存成功",
			auditApplyEncoding: "應用編碼策略",
			auditApplyEncodingDetail: "已為 {n} 個欄位應用編碼策略",
			msgConfigSavedContent: "數據編碼配置已成功儲存。您可以下載處理後的數據或繼續進行其他操作。",
			msgConfigSavedTitle: "配置儲存成功",
			msgApplyEncodingFailed: "應用編碼策略失敗",
			msgNoEncodingSelected: "未選擇任何編碼策略",
			msgProjectOrDatasetMissing: "項目或數據集未選擇",
			msgImputationApplied: "填補策略應用成功",
			auditApplyImputation: "應用填補策略",
			auditApplyImputationDetail: "已為 {n} 個欄位應用填補策略",
			msgApplyImputationFailed: "應用填補策略失敗",
			msgNoImputationSelected: "未選擇任何填補策略，直接進入編碼步驟。",
			msgApplyImputationError: "應用填補策略時發生錯誤",
			sampleData: "示例數據 {n}",
			colSampleData: "數據樣本",
			msgFetchPreviewFailed: "獲取數據預覽失敗",
			msgSaveConfigConfirm: "是否儲存當前數據處理配置？",
			msgConfigSaved: "配置已儲存",
			msgExportConfirm: "是否匯出處理後的數據？",
			exportDataTitle: "匯出數據",
			msgExportStarted: "數據匯出已開始",
			msgCancelConfirm: "是否取消當前操作並返回？未儲存的更改將遺失。",
			msgCancelTitle: "確認取消",
		},
		selection: {
			datasetSelection: "數據集選擇",
			chooseDataset: "選擇數據集",
			datasetPlaceholder: "請選擇要進行變量選擇的數據集",
			datasetCode: "數據集代碼",
			datasetName: "數據集名稱",
			prepProgress: "數據準備進度",
			roleAssignment: "列角色分配",
			autoDetectTarget: "自動檢測目標變量",
			selectAllFeatures: "全選為特徵",
			clearSelection: "清空選擇",
			selectAllAsX: "全選為X變量",
			autoDetectY: "自動檢測Y變量",
			colName: "列名",
			colDataType: "數據類型",
			colStats: "統計資訊",
			uniqueValues: "唯一值",
			missingRate: "缺失率",
			varType: "變量類型",
			selectType: "選擇類型",
			roleY: "Y變量 (目標)",
			roleGrouping: "分組變量",
			roleX: "X變量 (特徵)",
			roleId: "ID變量",
			roleExcluded: "排除",
			roleUnassigned: "未分配",
			powerAnalysis: "統計功效分析",
			runPowerAnalysis: "執行功效分析",
			alphaLevel: "顯著性水平 (α)",
			power: "統計功效",
			effectSize: "效應量",
			effectSmall: "小",
			effectMedium: "中",
			effectLarge: "大",
			detectedAnalysis: "檢測到{type}分析",
			regression: "迴歸",
			classification: "分類",
			powerAdequate: "統計功效充足",
			powerInadequate: "統計功效不足",
			currentSampleSize: "當前樣本量",
			recommendedSampleSize: "建議樣本量",
			actualPower: "實際功效",
			smartFeatureSelection: "智能特徵選擇",
			runFeatureSelection: "執行特徵選擇",
			featureSelectionAlertTitle: "基於統計功效分析的智能特徵選擇",
			featureSelectionAlertDesc: "使用Lasso迴歸識別最重要的特徵，同時確保樣本量充足以維持統計功效",
			recommendedFeatureCount: "推薦特徵數量",
			maxFeaturesAllowed: "最大允許特徵數",
			lassoAlpha: "Lasso參數α",
			importanceThreshold: "重要性閾值",
			recommendedFeatureList: "推薦特徵列表",
			applyRecommendedFeatures: "應用推薦特徵",
			featureImportanceTitle: "特徵重要性評分",
			sortDesc: "降序",
			sortOriginal: "原始順序",
			featureName: "特徵名稱",
			importanceScore: "重要性評分",
			optimizationSuggestions: "優化建議",
			saveConfig: "儲存配置",
			nextAlgorithm: "下一步：演算法選擇",
			columnDetailTitle: "列詳情：{name}",
			displayName: "顯示名",
			uniqueValueCount: "唯一值數",
			currentRole: "當前角色",
			confirmApply: "應用",
			msgSelectProject: "請先選擇項目",
			msgNoDatasets: "未找到可用的數據集",
			msgFetchDatasetsFailed: "獲取數據集列表失敗",
			msgCannotBeY: "該列不能作為Y變量（包含NaN值或數據類型不合適）",
			msgCannotBeGrouping: "該列不能作為分組變量（必須是分類變量）",
			msgNoColumnsForAutoDetect: "沒有可用的列來自動檢測Y變量。",
			msgAutoDetectedYMoved: "自動檢測到Y變量: {name} (原Y變量 {old} 已移至X變量)。",
			msgAutoDetectedY: "自動檢測到Y變量: {name}。",
			msgAutoDetectYFailed: "未能自動檢測到合適的Y變量。請手動選擇。",
			msgLoadSelectionFailed: "載入數據集 {dataset} 的列選擇配置失敗",
			msgSaveSelectionSuccess: "列選擇配置已儲存",
			msgSaveSelectionFailed: "儲存列選擇配置失敗",
			msgCompleteSelectionFirst: "請先完成列選擇配置",
			msgPowerAnalysisDone: "功效分析完成",
			msgPowerAnalysisFailed: "功效分析失敗",
			msgCompletePowerAnalysisFirst: "請先完成功效分析",
			msgFeatureSelectionDone: "智能特徵選擇完成，推薦 {n} 個特徵",
			msgFeatureSelectionFailed: "智能特徵選擇失敗",
			msgApplyFeaturesConfirm: "是否應用推薦的 {n} 個特徵作為X變量？這將替換當前的X變量選擇。",
			msgFeaturesApplied: "已應用推薦的特徵選擇",
			stepDatasetSelected: "數據集已選擇",
			stepTargetSet: "目標變量已指定",
			stepFeaturesSelected: "特徵變量已選擇",
			stepPowerAnalysisDone: "功效分析已完成",
			stepFeatureSelectionDone: "智能特徵選擇已完成",
			msgCompleteVarConfig: "請完成必要的變量配置",
			msgConfigSavedRedirect: "配置已儲存，正在跳轉到演算法選擇頁面",
			msgPrepareAnalysisFailed: "準備分析失敗: {msg}",
			msgInitFailed: "初始化失敗",
			msgProjectCleared: "項目資訊已清除，請重新選擇項目。",
		},
		algorithm: {
			datasetSelection: "資料集選擇",
			selectDataset: "選擇資料集",
			datasetPlaceholder: "請選擇要執行演算法的資料集",
			datasetCode: "資料集代碼",
			datasetName: "資料集名稱",
			configAndRun: "演算法配置與執行",
			dataConfigOverview: "資料配置概覽",
			backToDataPrep: "返回資料準備",
			targetVariable: "目標變量",
			analysisType: "分析類型",
			classification: "分類",
			regression: "迴歸",
			featureCount: "特徵變量數量",
			totalColumns: "總欄位數",
			selectedFeatures: "已選擇的特徵變量",
			moreFeatures: "+{n} 更多...",
			globalConfig: "全域配置",
			executing: "執行中... ({done}/{total})",
			runComparison: "執行演算法比較 ({selected}/{total})",
			optimizationMetric: "優化指標",
			metricAccuracy: "準確率",
			metricPrecision: "精確率",
			metricRecall: "召回率",
			metricF1: "F1分數",
			metricMae: "平均絕對誤差",
			metricMse: "均方誤差",
			metricRmse: "均方根誤差",
			metricR2: "R²值",
			cvFolds: "交叉驗證折數",
			autoTune: "自動調參",
			algorithmSelectionTitle: "演算法選擇與參數配置",
			emptyAlgorithms: "暫無可用演算法",
			recommended: "推薦",
			collapseParams: "收起參數",
			expandParams: "展開參數",
			paramConfig: "參數配置",
			noParamsNeeded: "此演算法無需參數配置",
			comparisonTitle: "演算法比較結果",
			exportComparison: "匯出比較結果",
			clearResults: "清除結果",
			bestAlgorithmTitle: "最優演算法: {name}",
			bestAlgorithmDesc: "基於{metric}指標，{name}表現最佳，得分: {score}",
			metricsComparison: "效能指標對比",
			colAlgorithm: "演算法",
			tagBest: "最優",
			colExecTime: "執行時間(秒)",
			comparisonCharts: "演算法對比圖表",
			chartsGeneratingTitle: "對比圖表生成中",
			chartsGeneratingDesc: "演算法對比圖表正在生成中，請稍後重新整理查看",
			chartPerformanceComparison: "演算法效能總體對比",
			chartPerformanceComparisonAlt: "演算法效能總體對比圖",
			chartMetricsHeatmap: "指標熱力圖",
			chartCvBoxplot: "交叉驗證分數分佈",
			chartCvBoxplotAlt: "交叉驗證分數分佈圖",
			chartRocComparison: "ROC曲線對比",
			chartRocComparisonAlt: "ROC曲線對比圖",
			chartPrComparison: "PR曲線對比",
			chartPrComparisonAlt: "PR曲線對比圖",
			detailedAnalysis: "{name} 詳細分析",
			chartFeatureImportance: "特徵重要性",
			chartFeatureImportanceAlt: "{name} 特徵重要性圖",
			featureImportanceUnavailable: "特徵重要性圖表不可用",
			chartConfusionMatrix: "混淆矩陣",
			chartConfusionMatrixAlt: "{name} 混淆矩陣",
			confusionMatrixUnavailable: "混淆矩陣圖表不可用",
			chartMetrics: "效能指標",
			chartMetricsAlt: "{name} 效能指標圖",
			chartRocCurve: "ROC曲線",
			chartRocCurveAlt: "{name} ROC曲線",
			executionLog: "執行日誌",
			noDatasetTitle: "請選擇資料集",
			noDatasetDesc: "請先選擇一個已完成資料準備配置的資料集來執行演算法分析",
			msgLoadConfigFailed: "載入資料配置失敗",
			msgLoadAnalysisFailed: "載入已有分析失敗",
			msgLoadAlgorithmsFailed: "取得可用演算法失敗",
			msgSelectAtLeastOne: "請至少選擇一個演算法",
			msgExecuteSuccess: "成功執行 {n} 個演算法",
			msgComparisonFailed: "演算法執行失敗: {msg}",
			msgCompleteConfig: "請完成資料配置並選擇演算法",
			msgScheduleCreated: "演算法定期執行計劃已建立",
			msgExecuteFailed: "執行演算法失敗",
			msgChartImageFailed: "圖表圖片載入失敗",
			msgComparisonExported: "比較結果已匯出",
			msgNoProjectInfo: "無法取得項目資訊以載入資料集，請確保已選擇一個項目。",
			msgNoDatasets: "未找到可用的資料集或資料格式不正確",
			msgLoadDatasetsFailed: "取得資料集清單失敗: {msg}",
			msgInitFailed: "初始化失敗",
		},
		report: {
			contextTitle: "研究背景資訊",
			analysisDone: "已完成演算法分析",
			analysisPending: "等待演算法分析",
			projectCode: "項目代碼:",
			dataset: "資料集:",
			sampleSize: "樣本量:",
			casesUnit: "例",
			bestAlgorithm: "最佳演算法:",
			targetVariable: "目標變數:",
			modelPerformance: "模型效能:",
			configTitle: "報告配置",
			loadConfig: "載入配置",
			refreshList: "重新整理清單",
			saveConfig: "儲存配置",
			generateStrobe: "生成STROBE報告",
			selectDatasetFirst: "請先選擇資料集",
			selectDatasetHint: "請選擇一個已完成資料處理和演算法分析的資料集來生成報告",
			datasetPlaceholder: "選擇資料集",
			sectionBasic: "基本資訊",
			studyTitle: "研究標題",
			studyTitlePlaceholder: "例如：XXX治療方案對患者預後的影響研究",
			researchObjective: "研究目標",
			researchObjectivePlaceholder: "請詳細描述您的研究目標，包括：\n1. 研究問題或假設\n2. 預期要驗證的關係\n3. 臨床意義或應用價值\n\n示例：本研究旨在評估不同化療方案對晚期胃癌患者總生存期的影響，並分析患者基線特徵對治療效果的預測價值，以為臨床治療決策提供循證依據。",
			studyDesign: "研究設計類型",
			studyDesignPlaceholder: "選擇研究設計類型",
			design: {
				retrospectiveCohort: "回顧性隊列研究",
				prospectiveCohort: "前瞻性隊列研究",
				caseControl: "病例對照研究",
				crossSectional: "橫斷面研究",
				cohort: "隊列研究",
			},
			sectionReferences: "參考文件",
			documentManagement: "文件管理",
			dropFilesHere: "將檔案拖曳到此處或",
			clickToUpload: "點擊上傳",
			uploadTip: "支援文件(.pdf, .doc, .docx, .txt, .md)、資料檔案(.xlsx, .xls, .csv)、圖片(.jpg, .png, .gif, .svg)、壓縮檔(.zip, .rar)等格式",
			descriptionPlaceholder: "新增文件描述（可選）",
			uploadFiles: "上傳檔案",
			uploadedFiles: "已上傳的參考文件 ({n})",
			refresh: "重新整理",
			col: {
				filename: "檔案名稱",
				size: "大小",
				uploadTime: "上傳時間",
				description: "描述",
				reportName: "報告名稱",
				templateType: "範本類型",
				status: "狀態",
				createdAt: "建立時間",
			},
			noDescription: "無描述",
			download: "下載",
			noReferenceFiles: "暫無參考文件，可以上傳相關的臨床指南、研究文獻等文件",
			studyBackground: "研究背景",
			studyBackgroundPlaceholder: "簡要描述研究背景和臨床問題（可選）",
			studyPeriod: "研究時間範圍",
			rangeSeparator: "至",
			startTime: "開始時間",
			endTime: "結束時間",
			monthFormat: "YYYY年MM月",
			sectionReportSettings: "報告設定",
			reportTemplate: "報告範本",
			tplCompleteTitle: "完整STROBE報告",
			tplCompleteDesc: "包含STROBE檢查表的所有22個條目",
			tplEssentialTitle: "核心STROBE報告",
			tplEssentialDesc: "關鍵條目的簡化版本",
			tplClinicalTitle: "臨床總結報告",
			tplClinicalDesc: "面向臨床應用的簡明報告",
			outputFormat: "輸出格式",
			fmtHtml: "HTML網頁版",
			fmtPdf: "PDF文件",
			fmtWord: "Word文件",
			language: "語言",
			langZh: "中文",
			langEn: "英文",
			langBoth: "中英雙語",
			advancedOptions: "進階選項",
			collapse: "收起",
			expand: "展開",
			includeSections: "包含章節",
			sec: {
				titleAbstract: "標題和摘要",
				introduction: "引言",
				methods: "方法",
				results: "結果",
				discussion: "討論",
				conclusion: "結論",
				limitations: "局限性",
				funding: "資助資訊",
			},
			specialRequirements: "特殊要求",
			specialRequirementsPlaceholder: "其他特殊要求或說明（可選）",
			historyTitle: "歷史報告",
			previewTitle: "報告預覽",
			generatingReport: "正在生成報告，請稍候...",
			noReportContent: "暫無報告內容",
			downloadReport: "下載報告",
			rule: {
				studyTitleRequired: "請輸入研究標題",
				studyTitleMin: "標題至少5個字元",
				researchObjectiveRequired: "請輸入研究目標",
				researchObjectiveOptional: "研究目標可選填寫",
			},
			msg: {
				fetchProjectFailed: "獲取項目資訊失敗",
				selectProjectFirst: "請先選擇項目",
				fetchDatasetsFailed: "獲取資料集清單失敗",
				defaultStudyTitle: "{name}資料分析報告",
				loadDatasetFailed: "載入資料集資訊失敗",
				completeRequired: "請完善必填資訊",
				reportGenerating: "報告正在生成中，請稍候...",
				reportGenerated: "報告生成成功！",
				generateFailed: "生成報告失敗: {msg}",
				configSaved: "報告配置已儲存",
				saveConfigFailed: "儲存配置失敗: {msg}",
				configsRefreshing: "配置清單正在重新整理，請稍候",
				configLoaded: "已載入配置: {name}",
				loadConfigFailed: "載入配置失敗: {msg}",
				configsRefreshed: "配置清單已重新整理",
				refreshConfigsFailed: "重新整理配置清單失敗",
				reportDetailUnavailable: "報告詳情不可用",
				loadReportFailed: "載入報告失敗",
				noReportId: "無法獲取報告ID",
				downloadStarted: "報告下載已開始",
				downloadReportFailed: "下載報告失敗",
				reportsRefreshed: "報告清單已重新整理",
				loadReferenceFilesFailed: "載入參考文件失敗",
				fileTooLarge: "檔案大小不能超過50MB",
				selectFilesToUpload: "請選擇要上傳的檔案",
				projectInfoIncomplete: "項目資訊不完整",
				uploadSuccess: "檔案上傳成功",
				uploadFailed: "檔案上傳失敗: {msg}",
				unknownError: "未知錯誤",
				fileDownloaded: "檔案下載完成",
				fileDownloadFailed: "檔案下載失敗",
				confirmDeleteFile: "確定要刪除檔案 \"{name}\" 嗎？此操作不可撤銷。",
				confirmDeleteTitle: "確認刪除",
				fileDeleted: "檔案刪除成功",
				fileDeleteFailed: "檔案刪除失敗",
				iframeLoadFailed: "報告內容載入失敗，請檢查檔案URL是否正確",
				fetchProjectFailedPartial: "獲取項目資訊失敗，部分功能可能受限",
				initFailed: "初始化失敗: {msg}",
				defaultConfigName: "配置_{time}",
			},
			status: {
				generating: "生成中",
				completed: "已完成",
				failed: "失敗",
				pending: "等待中",
			},
		},
	},
	clinic: {
		operationOverview: "營運概覽",
		appointments: "加號申請",
		checkins: "報到列表",
		chatHistory: "聊天歷史",
		users: "門診用戶管理",
		refresh: "重新整理",
		today: "今日",
		last7d: "近7天",
		last30d: "近30天",
		last90d: "近90天",
		custom: "自訂",
		dateSep: "至",
		startDate: "開始日期",
		endDate: "結束日期",
		kpiTotalUsers: "累計用戶",
		kpiNewUsers: "期內新增用戶",
		kpiActiveUsers: "活躍用戶",
		kpiDeactivated: "已停用帳號",
		kpiSnapshot: "目前快照",
		kpiMessages: "期內訊息總數",
		kpiConversations: "期內對話總數",
		kpiUploads: "期內上傳病歷數",
		kpiFollowupMessages: "期內隨訪訊息",
		recentRegistrations: "近期註冊",
		// 門診用戶管理 list
		searchPlaceholder: "搜尋暱稱 / 手機號 / openid",
		searchBtn: "搜尋",
		showDeleted: "顯示已註銷帳號",
		totalCount: "共 {n} 條",
		emptyUsers: "暫無用戶",
		colUser: "用戶",
		colContact: "聯絡方式",
		colLoginType: "登入方式",
		colLastLogin: "最近登入",
		colStatus: "狀態",
		colRemark: "備註",
		colActions: "操作",
		statusDeleted: "已註銷",
		statusActive: "已開通",
		statusDisabled: "已停用",
		loginWechat: "微信",
		loginPassword: "帳號",
		loginBoth: "雙綁",
		internalFlag: "可體驗新功能",
		disable: "停用",
		restore: "恢復",
		disableTitle: "停用帳號",
		restoreTitle: "恢復帳號",
		disableConfirm: "即將{action}用戶 {name}。",
		disableNote: "停用後該用戶登入將提示「您的帳號暫無存取權限」，無法繼續使用，但已有的資料保留。",
		reasonLabel: "原因（可選，會展示給用戶）",
		confirm: "確定",
		cancel: "取消",
		save: "儲存",
		opSuccess: "操作成功",
		opFailed: "操作失敗",
		loadFailed: "載入失敗",
		internalOn: "已設為可體驗新功能",
		internalOff: "已取消體驗權限",
		viewDetail: "詳情",
		// 用戶詳情 page
		userDetail: "用戶詳情",
		backToList: "返回列表",
		profile: "用戶資料",
		loginCount: "登入次數",
		createdAt: "註冊時間",
		lastLoginIp: "登入IP",
		patientTimelines: "患者時間線",
		noPatients: "暫無患者檔案",
		correctionHint: "時間線由系統自動生成，醫生可修正；用戶提交的原始聊天與資料不可編輯。",
		tabConversations: "會話記錄",
		tabAppointments: "加號申請",
		tabCheckins: "報到記錄",
		tabAssessments: "評估結果",
		convTitle: "會話標題",
		convTheme: "話題",
		convPending: "待回覆",
		convMessages: "訊息數",
		convLastActive: "最近活動",
		patient: "患者",
		// 患者時間線 component
		patientInfo: "患者資訊",
		patientName: "姓名",
		patientGender: "性別",
		patientDob: "出生日期",
		hospitalCards: "就診卡",
		baseline: "基線",
		followUps: "隨訪記錄",
		viewSource: "查看來源",
		assessmentSource: "來源：問卷評估",
		timelineMissing: "未找到患者時間線資料",
		correctedBadge: "醫生已修正",
		correctedAt: "修正時間",
		editEvent: "編輯",
		deleteEvent: "刪除",
		editEventTitle: "修正隨訪事件",
		eventDate: "日期",
		eventType: "事件類型",
		removeField: "刪除欄位",
		undoRemove: "復原刪除",
		complexFields: "複雜欄位",
		complexFieldsNote: "結構化欄位，以 JSON 格式編輯；儲存前會校驗格式。",
		invalidJson: "{key} 的 JSON 格式有誤，請檢查後再儲存",
		addField: "新增欄位",
		fieldKey: "欄位名",
		fieldValue: "值",
		add: "新增",
		reservedFieldKey: "該欄位為系統保留欄位",
		duplicateFieldKey: "欄位已存在",
		noChanges: "未偵測到修改",
		correctionSaved: "修正已儲存",
		correctionFailed: "操作失敗，請稍後重試",
		deleteEventTitle: "刪除確認",
		deleteEventConfirm: "確認刪除該隨訪事件（{type} {date}）？此操作不可復原。",
		eventDeleted: "已刪除",
	},
	discern: {
		title: "AI辨識列表",
		uploader: "上傳用戶：",
		userType: "用戶類型：",
		identifyStatus: "辨識狀態：",
		confirmStatus: "確認狀態：",
		input: "請輸入",
		select: "請選擇",
		userDoctor: "醫生",
		userPatient: "患者",
		userSys: "管理員",
		statusUnfinished: "未完成",
		statusFinished: "已完成",
		statusPending: "待確認",
		statusConfirmed: "已確認",
		searchBtn: "查 詢",
		resetBtn: "重 置",
		qrCode: "二維碼",
		batchUpload: "批次上傳",
		colIndex: "序號",
		colUploader: "上傳用戶",
		colUserType: "用戶類型",
		colProject: "項目名稱",
		colFileCount: "圖片數量",
		colUploadTime: "上傳時間",
		colIdentifyStatus: "辨識狀態",
		colIdentifyTime: "辨識時間",
		colConfirmStatus: "確認狀態",
		colConfirmUser: "確認用戶",
		colConfirmTime: "確認時間",
		colOperation: "操作",
		actView: "查看",
		actConfirm: "確認",
		viewTitle: "AI辨識詳情",
		batchUploadTitle: "批次上傳",
		dropFiles: "將檔案拖到此處，或",
		clickUpload: "點擊上傳",
		fileTip: "僅支援 JPG/PNG，單檔案不超過 10MB",
		startUpload: "開始上傳",
	},
	governance: {
		title: "審批收件匣",
		myTitle: "我的申請",
		refresh: "重新整理",
		colId: "申請ID",
		colType: "類型",
		colRequester: "申請人",
		colCreatedAt: "申請時間",
		colStatus: "狀態",
		colOperation: "操作",
		actView: "查看",
		actApprove: "通過",
		actReject: "駁回",
		statusPending: "待審批",
		statusApproved: "已通過",
		statusRejected: "已駁回",
		statusCancelled: "已取消",
		drawerTitle: "申請詳情",
		approve: "通過",
		reject: "駁回",
		comment: "審批意見",
		commentPh: "請輸入審批意見",
		noPendingStep: "沒有待審批步驟",
		emptyCommentConfirm: "駁回建議填寫理由,確定空備註提交嗎?",
		confirmTitle: "確認",
		toastApproved: "已通過",
		toastRejected: "已駁回",
		quickConfirmBody: "{action} 申請 #{id}?",
		quickConfirmTitle: "確認操作",
	},

	consent: {
		admin: {
			tabTemplates: "範本管理",
			tabSignatures: "醫生簽名",
			noProject: "缺少項目參數，請從項目管理頁進入。",
			noPermission: "您沒有知情同意書範本管理權限，請聯絡系統管理員。",
			templateHint: "同一類型下只能有一個已發佈版本；已發佈的範本不可修改，如需調整請新建版本。",
			templateEmpty: "該項目還沒有知情同意書範本",
			newTemplate: "新建範本",
			colFamily: "類型",
			colName: "名稱",
			colVersion: "版本",
			colStatus: "狀態",
			colSource: "來源",
			colPages: "頁數",
			colUpdated: "更新時間",
			colActions: "操作",
			status: {
				DRAFT: "草稿",
				ACTIVE: "已發佈",
				RETIRED: "已停用",
			},
			actZones: "標註",
			actPreview: "預覽",
			actEdit: "編輯",
			actPublish: "發佈",
			actRetire: "停用",
			actNewVersion: "新版本",
			actDelete: "刪除",
			familyHint: "同一份同意書的類型標識，例如 F2F（面對面）、PHONE（電話）",
			versionHint: "例如 V3.0a",
			sourcePdf: "PDF 上傳",
			sourceText: "純文字",
			file: "範本檔案",
			chooseFile: "選擇 PDF",
			fileHint: "僅支援未加密的 PDF 檔案",
			textBody: "正文",
			textHint: "系統據此生成 PDF，並自動附加一頁標準簽名頁",
			remark: "備註",
			effectiveDate: "生效日期",
			effectiveDatePlaceholder: "選擇日期",
			editMeta: "編輯範本資料",
			createIncomplete: "請填寫類型、名稱與版本",
			needPdf: "請選擇 PDF 範本檔案",
			needText: "請填寫範本正文",
			createDone: "範本已建立（草稿）",
			saveDone: "已儲存",
			publishConfirm: "確定發佈「{name}」？同類型下已發佈的版本將自動停用。",
			publishDone: "範本已發佈",
			retireConfirm: "確定停用「{name}」？停用後簽署頁將不再顯示該版本。",
			retireDone: "範本已停用",
			newVersionBody: "基於 {version} 複製為新草稿，請輸入新的版本號",
			versionRequired: "請輸入版本號",
			newVersionDone: "新版本草稿已建立",
			deleteConfirm: "確定刪除「{name}」{version}？此操作不可復原。",
			deleteDone: "範本已刪除",
			zoneTitle: "標註簽名區域",
			zoneList: "區域列表",
			zoneEmpty: "還沒有標註任何區域",
			zoneNoSelection: "在左側頁面上拖曳以新建區域，或點擊已有區域進行編輯",
			zoneReadonly: "唯讀",
			zoneReadonlyHint: "已發佈/已停用的範本不可修改標註，如需調整請新建版本",
			zoneDrawHint: "拖曳空白處新建區域；拖曳方框移動；拖曳角點縮放；Delete 刪除選取區域",
			zoneDirty: "有未儲存的修改",
			zoneSave: "儲存標註",
			zoneSaved: "標註已儲存",
			zoneDiscardTitle: "放棄未儲存的修改？",
			zoneDiscardBody: "標註尚未儲存，關閉後修改將遺失。",
			zoneKey: "標識 (key)",
			zoneKeyHint: "小寫字母、數字與底線，1-32 位；簽署時用於配對簽名圖片",
			zoneKeyInvalid: "只允許小寫字母、數字與底線，1-32 位",
			zoneKeyInvalidAt: "區域標識「{key}」不合法：只允許小寫字母、數字與底線，1-32 位",
			zoneKeyDuplicate: "區域標識「{key}」重複",
			zoneType: "類型",
			zoneRole: "角色",
			zoneLabel: "顯示名稱",
			zoneSource: "自動填入",
			zonePage: "頁碼",
			zoneFormat: "格式",
			zoneFormatHint: "例如 yyyy年MM月dd日；日期類區域必填",
			zoneRect: "位置與大小（頁面比例 0-1）",
			zoneRectHint: "x/y 為左上角座標，w/h 為寬高，均為頁面寬高的比例",
			zoneRequired: "必填",
			zoneMask: "覆蓋底紋",
			zoneMaskHint: "簽署時先塗白該區域，用於覆蓋預印文字",
			zoneDelete: "刪除該區域",
			prevPage: "上一頁",
			nextPage: "下一頁",
			type: {
				SIGNATURE: "簽名",
				DATE: "日期",
				DATETIME: "日期時間",
				DATETIME_RANGE: "時間區間",
				TEXT: "文字",
				CHECKBOX: "勾選框",
			},
			source: {
				none: "不自動填入",
				patient_no: "研究參與者篩選號",
				patient_name: "研究參與者姓名",
				doctor_name: "研究人員姓名",
				signed_date: "簽署日期",
			},
			signatureHint: "為項目成員維護簽名圖片；簽署時「研究人員」區域使用登入者本人的簽名。",
			memberEmpty: "該項目還沒有成員",
			colNickname: "姓名",
			colUsername: "帳號",
			colSignature: "簽名",
			noSignature: "未設定",
			actUpload: "上傳",
			actDraw: "手寫",
			actDeleteSignature: "刪除",
			chooseImage: "選擇圖片",
			uploadHint: "建議使用背景透明的 PNG；若為白底掃描件，請勾選「去除白底」。",
			needImage: "請選擇簽名圖片",
			needDrawing: "請先完成簽名",
			signatureSaved: "簽名已儲存",
			signatureDeleted: "簽名已刪除",
			deleteSignatureConfirm: "確定刪除 {name} 的簽名？",
		},
		panel: {
			title: "知情同意書",
			sign: "簽署知情同意書",
			empty: "暫無簽署記錄",
			colTemplate: "模板",
			colVersion: "版本",
			colSignedDate: "簽署日期",
			colDoctor: "研究人員",
			colStatus: "狀態",
			view: "查看",
			download: "下載",
			voidAction: "作廢",
			voidPromptTitle: "作廢簽署記錄",
			voidPromptBody: "作廢後該記錄不再作為有效知情同意，檔案仍會保留。請填寫作廢原因（{template}）。",
			voidReasonPlaceholder: "請填寫作廢原因，200 字以內",
			voidReasonRequired: "請填寫作廢原因",
			voidReasonTooLong: "作廢原因不能超過 200 字",
			voidDone: "已作廢",
		},
		status: {
			SIGNED: "已簽署",
			VOID: "已作廢",
		},
		role: {
			PATIENT: "研究參與者",
			DOCTOR: "研究人員",
			GUARDIAN: "監護人",
			WITNESS: "公正見證人",
			OTHER: "其他資料",
		},
		dialog: {
			title: "簽署知情同意書",
			stepTemplate: "選擇模板",
			stepRead: "閱讀全文",
			stepSign: "簽名",
			prev: "上一步",
			next: "下一步",
			submit: "確認簽署",
			selectTemplateHint: "請選擇本次需要簽署的知情同意書版本",
			readHint: "請與研究參與者一起閱讀全文；捲動至最後一頁後方可繼續。",
			readEnd: "已到全文末尾",
			pageOf: "第 {n} 頁 / 共 {total} 頁",
			signedDate: "簽署日期",
			signedDateHint: "預設為今天，可修改",
			followsSignedDate: "跟隨上方簽署日期",
			rangeStart: "開始時間",
			rangeEnd: "結束時間",
			noZones: "此模板尚未標註簽名區域，請聯絡項目管理員。",
			optionalSection: "如適用",
			expand: "展開",
			collapse: "收起",
			signature: "簽名",
			submitSuccess: "簽署成功",
			templateLoadFailed: "模板載入失敗",
			popupBlocked: "簽署成功。瀏覽器攔截了新視窗，可在下方列表中點擊「查看」開啟。",
		},
		doctor: {
			stored: "已存簽名",
			redraw: "重新簽名",
			useStored: "使用已存簽名",
			saveAsMine: "儲存為我的簽名",
			noStored: "您尚未儲存簽名，可勾選後儲存本次簽名。",
		},
		pad: {
			tabDraw: "手寫",
			tabUpload: "上傳圖片",
			tabType: "輸入姓名",
			drawHint: "請在下方區域內簽名",
			upload: "選擇圖片",
			whiteToAlpha: "去除白底",
			namePlaceholder: "請輸入姓名",
			undo: "復原",
			clear: "清除",
			required: "必填",
			optional: "選填",
			imageFailed: "圖片讀取失敗",
			notImage: "請選擇圖片檔案",
		},
		validate: {
			signatureRequired: "請完成「{label}」簽名",
			valueRequired: "請填寫「{label}」",
			rangeInvalid: "「{label}」的結束時間不能早於開始時間",
		},
	},
	basicInfo: {
		doctor: "負責醫生",
		maskedDoctor: "***醫生",
		hospital: "所屬機構",
		maskedHospital: "****醫院",
		input: "請輸入",
		enrollDate: "入組日期",
		select: "請選擇",
		status: "入組狀態",
		diagnosis: "診斷",
		diagnosisPh: "請輸入診斷",
	},
	patientInfo: {
		patientNo: "患者編號",
		randomNo: "隨機號",
		name: "姓名",
		gender: "性別",
		age: "年齡",
		ageUnit: "歲",
		dob: "出生日期",
		phone: "聯絡電話",
		idNumber: "證件號",
		project: "所屬項目",
		enrollDate: "入組日期",
		status: "入組狀態",
		doctor: "負責醫生",
		hospital: "所屬機構",
	},
	followupRecord: {
		recordTitle: "隨訪記錄",
		newRecord: "新增隨訪",
		emptyHint: "暫無隨訪記錄",
		actView: "查看",
		actEdit: "編輯",
		actDelete: "刪除",
		visitName: "訪視",
		dueDate: "應到日期",
		actualDate: "實際日期",
		statusPending: "未隨訪",
		statusOverdue: "已超窗",
		statusDone: "已隨訪",
		confirmCancel: "確認取消該次隨訪？",
		menuSelect: "範本選擇",
		menuDelete: "刪除範本",
		menuAdd: "新增非計劃隨訪",
		dialogSelectTitle: "選擇隨訪計劃範本",
		dialogAddTitle: "新增非計劃隨訪",
		fieldProjectName: "項目名稱：",
		fieldTemplate: "選擇範本：",
		fieldStart: "起始日期：",
		select: "請選擇",
		datePh: "選擇隨訪日期",
		ruleTemplate: "請選擇範本",
		ruleStart: "請選擇起始時間",
		generatePlan: "生成計劃",
		confirmDelete: "刪除後不可恢復，確認刪除？",
		confirmDeleteOne: "確定刪除該條隨訪記錄？刪除後不可恢復。",
		dialogTipTitle: "提示",
		deleteSuccess: "刪除成功",
		dialogEditTitle: "編輯隨訪記錄",
		fieldVisitName: "隨訪名稱",
		fieldVisitType: "隨訪類型",
		typePlan: "計劃隨訪",
		typeNoPlan: "非計劃隨訪",
		fieldPlan: "隨訪計劃",
		fieldConfig: "計劃節點",
		namePh: "請輸入隨訪名稱",
		rulePlan: "請選擇隨訪計劃",
		ruleConfig: "請選擇計劃節點",
		editSuccess: "修改成功",
	},
	upgradation: {
		dialogTitle: "升級會員",
		selectLevel: "選擇會員等級",
		level: "等級",
		duration: "時長",
		monthly: "{n}個月",
		yearly: "{n}年",
		price: "價格",
		discount: "認證用戶享 5 折",
		payNow: "立即支付",
		paySuccess: "支付成功",
		payFailed: "支付失敗",
		qrTip: "請使用微信掃碼支付",
	},
	fileUpload: {
		click: "點擊上傳",
		drop: "或將檔案拖到此處",
		tip: "支援 JPG / PNG / PDF",
		preview: "預覽",
		download: "下載",
		remove: "刪除",
		removeConfirm: "確認移除該檔案？",
		uploading: "上傳中…",
		uploaded: "已上傳",
		uploadFailed: "上傳失敗",
		uploadFailedWithReason: "上傳被拒絕：{reason}",
		duplicateRejected: "重複檔案被拒絕——此檔案已為該病人上傳過。",
		exceed: "檔案數量超出限制",
		view: "查看",
		upload: "上傳",
		dialogUploadTitle: "上傳檔案",
		dialogViewTitle: "查看檔案",
		cancelUpload: "取消上傳",
		selectFile: "檔案上傳",
		dragHint: "拖拽檔案至此，或",
		clickToSelect: "選擇檔案上傳",
		aiOcr: "AI識別",
		submitted: "已提交識別",
		selectAll: "全選",
		selected: "已選 {n}",
		emptyData: "暫無資料",
	},
	patientList: {
		patientNoOrName: "患者編號/姓名：",
		enrollDate: "入組日期：",
		startDate: "開始時間",
		endDate: "結束時間",
		center: "所屬中心：",
		searchPlaceholder: "請輸入",
		searchKeyword: "請輸入關鍵字",
		searchBtn: "查 詢",
		resetBtn: "重 置",
		colIndex: "序號",
		colCompleteness: "完整度",
		colOperation: "操作",
		dragReorderTip: "拖動調整欄位順序（僅本機生效）",
		actDetail: "患者詳情",
		actFollowup: "隨訪詳情",
		actImaging: "影像",
		actImagingWorkspace: "影像工作台",
		actTimeSeries: "時序",
		actDelete: "刪除資料",
		deleteSuccess: "刪除成功",
		deleteConfirm: "確認刪除此患者資料？該操作不可撤銷。",
		deleteTitle: "提示",
		add: "新增患者",
		export: "匯出",
		batchEnroll: "批次入組",
		import: "匯入",
		advancedFilter: "進階篩選",
		colPatientNo: "患者編號",
		colName: "姓名",
		colGender: "性別",
		colBirth: "出生日期",
		colAge: "年齡",
		colEnrollDate: "入組日期",
		colCenter: "所屬中心",
		genderMale: "男",
		genderFemale: "女",
		genderUnknown: "未知",
		ageYears: "歲",
		viewSource: "溯源",
	},
	patientDetail: {
		add: "新增患者",
		edit: "編輯患者",
		fileView: "患者檔案視圖",
		basicInfo: "基本資訊",
		save: "儲存",
		saveDraft: "暫存",
		discard: "放棄修改",
		nextForm: "下一步",
		prevForm: "上一步",
		visitRecords: "就診記錄",
		followups: "隨訪記錄",
		documents: "影像/檔案",
		newVisit: "新增就診",
		fieldRequired: "請輸入",
	},
	retrieval: {
		title: "資料檢索",
		exportTitle: "資料檢索-匯出",
		searchPlaceholder: "請輸入關鍵字",
		newQuery: "新建查詢",
		runQuery: "執行查詢",
		exportResult: "匯出結果",
		conditions: "篩選條件",
		results: "查詢結果",
		colIndex: "序號",
		colName: "查詢名稱",
		colCreatedAt: "建立時間",
		colOperation: "操作",
		actView: "查看",
		actEdit: "編輯",
		actDelete: "刪除",
		actExport: "匯出",
		actRun: "執行",
		deleteGroup: "刪除分組",
		selectValues: "請選擇值",
		enterValue: "請輸入值",
		fieldTreeFailed: "欄位列表載入失敗",
		selectAnalysisField: "請先選擇要分析的欄位",
		condition: {
			is: "等於",
			ne: "不等於",
			gt: "大於",
			gte: "大於等於",
			lt: "小於",
			lte: "小於等於",
			regex: "全部模糊匹配",
			exists: "是否存在",
			in: "在指定的陣列中",
			nin: "不在指定的陣列中",
			all: "陣列包含所有指定的元素",
			yes: "是",
			no: "否",
			and: "符合所有條件",
			or: "符合任意條件",
			nor: "均不符合條件",
		},
		stats: {
			title: "檢索結果統計",
			chart: "統計圖",
			chartTypePlaceholder: "請選擇分析圖形",
			startDate: "開始日期",
			endDate: "結束日期",
			startDatePlaceholder: "請選擇開始日期",
			endDatePlaceholder: "請選擇結束日期",
			barChart: "柱狀圖",
			pieChart: "餅狀圖",
			sampleSize: "樣本量",
			max: "最大值",
			min: "最小值",
			median: "中位數",
			avg: "平均數",
		},
		exportPage: {
			searchConditions: "檢索條件",
			saveAsTemplate: "儲存為範本",
			resultList: "檢索結果列表",
			colPatientNo: "患者編號",
			colPatientName: "患者姓名",
			colEnrollmentDate: "入組日期",
			colAge: "年齡",
			colBirthday: "出生日期",
			colDoctor: "負責醫生",
			colEnrollmentStatus: "入組狀態",
			colLastUpdated: "最近更新日期",
			colUpdatedBy: "最近更新用戶",
			colDataManage: "資料管理",
			patientDetail: "患者詳情",
			followUpDetail: "隨訪詳情",
			templateNamePlaceholder: "請輸入範本名稱",
			templateNameRequired: "請輸入範本名稱",
			templateSaved: "儲存範本成功",
			joinSubProject: "入組子項目",
			existingSubProjects: "已有子項目",
			subProjectName: "子項目名稱",
			projectStartDate: "項目啟動日期",
			projectEndDate: "項目結束日期",
			enrolledCount: "已入組人數",
			actEnrol: "入組",
			addSubProject: "新增子項目",
			basicInfo: "基本資訊",
			rootProjectName: "根項目名稱",
			projectLeader: "項目負責人",
			leaderUnit: "負責人單位",
			projectGoal: "項目目標",
			selectSubProject: "請選擇子項目",
			aiFilterTag: "AI 篩選",
		},
		exportDialog: {
			title: "資料匯出",
			exportAll: "匯出全部表單和模型",
			exportPartial: "匯出部分表單和模型",
			selectForms: "請選擇您要匯出的表單和模型",
			approvalConfirm: "本項目匯出需經審批通過後方可下載。是否提交匯出申請?",
			approvalTitle: "需要審批",
			submitRequest: "提交申請",
			requestId: "申請編號",
			status: "狀態",
			requestPending: "匯出申請已提交,等待審核人審批。可在「我的申請」中查看進度。",
			requestSubmitted: "匯出申請已提交",
			goToMyRequests: "前往我的申請",
		},
		aiFilter: {
			history: "歷史對話",
			newChat: "+ 新對話",
			noConversations: "暫無歷史對話",
			untitled: "未命名",
			matchedTag: "命中 {n}",
			emptyIntro: "用一段話描述篩選要求——AI 會在項目最新資料快照上編寫並執行篩選程式碼。",
			emptyIntroSub: "可以隨時追加訊息細化條件；遇到會顯著影響結果的口徑分叉時，AI 會向你提問而不是擅自決定。每輪一般需要 1~5 分鐘。",
			optCount: "{n} 例",
			letAiDecide: "讓 AI 自行決定",
			turnMatched: "本輪命中 {n} 例患者",
			viewResult: "查看結果 →",
			ctrlEnterHint: "Ctrl+Enter 傳送",
			working: "執行中…",
			send: "傳送",
			resultPlaceholder: "最新一輪的篩選結果會顯示在這裡。",
			matchedPatients: "匹配 {n} 例患者",
			totalInProject: "項目共 {n} 例",
			criteriaFunnel: "條件命中漏斗",
			colCriterion: "篩選條件",
			colStandalone: "單獨命中",
			colCumulative: "累計命中",
			expansionSuggestions: "擴大範圍建議",
			estimatedAdditional: "預計+{n}例",
			applySuggestion: "採納並重新篩選",
			samplesLabel: "樣例：",
			exportExcel: "匯出 Excel",
			exportDataset: "匯出為分析資料集",
			startResearch: "開始研究分析",
			confirmAndView: "確認並查看結果",
			datasetDialogTitle: "匯出為分析資料集",
			datasetName: "資料集名稱",
			datasetHint: "將把命中患者攤平為每人一行的寬表資料集，並登記到「研究資料」庫中，可直接在分析工作台使用。",
			datasetCreated: "資料集已建立",
			create: "建立",
			openLibrary: "前往研究資料庫",
			retry: "重試",
			followUpPlaceholder: "繼續對話：細化條件、回答上面的問題，或要求擴大/縮小範圍…",
			examplePlaceholder: "例如：診斷為缺血性卒中（大動脈粥樣硬化型或心源性栓塞型）、既往有高血壓或糖尿病史，並且（任一次隨訪收縮壓大於150，或基線NIHSS評分≥10）的患者",
			exportingSnapshot: "正在匯出資料快照 {docs}/{total}…",
			filterFailed: "AI 篩選失敗",
			starting: "正在啟動…",
			runInProgress: "已有一個 AI 篩選正在執行，請稍候",
			noProjectAccess: "無權在當前項目執行 AI 篩選",
			conversationGone: "對話不存在或已被刪除",
			filterRunFailed: "AI 篩選執行失敗",
			cancelled: "已取消",
			autoDecidePrompt: "你決定——按臨床上最合理的預設口徑繼續執行，這個問題不用再問。",
			adjustmentPrefix: "補充調整：",
			replayMatched: "**本輪命中 {n} 例患者。**",
			conversationDataGone: "該對話的資料已不可恢復",
			openConversationFailed: "開啟對話失敗",
			deleteConversationConfirm: "刪除「{title}」？雲端儲存的副本也會一併刪除。",
			deleteConversationTitle: "刪除對話",
			deleteFailed: "刪除失敗",
			matchesDisplayName: "AI篩選命中患者",
			startResearchFailed: "啟動研究分析失敗",
			sessionExpiredExport: "登入已過期，請重新登入後再匯出",
			exportInProgress: "已有一個匯出正在進行，請稍候",
			excelExportFailed: "Excel 匯出失敗，請稍後重試",
			datasetNamePrefix: "AI篩選",
			datasetResult: "{name}：{rows} 名患者，{cols} 欄",
			datasetExportFailed: "資料集匯出失敗",
			datasetExportInProgress: "已有一個資料集匯出正在進行，請稍候",
			datasetExportStartFailed: "資料集匯出啟動失敗",
			excelFilenamePrefix: "AI篩選",
		},
		savedSearches: "常用搜尋",
		pickTemplatePlaceholder: "請選擇範本",
		group: "組合",
		clearAll: "一鍵清空",
		addOrPickCondition: "請新增或選擇檢索條件",
		fieldNamePlaceholder: "輸入檢索欄位的名稱",
		aiFilterTab: "AI 篩選",
	},
	analysis: {
		title: "資料分析",
		runAnalysis: "執行分析",
		results: "分析結果",
		exportResult: "匯出報告",
		emptyHint: "請先選擇欄位並執行分析",
	},
	projectManage: {
		title: "項目列表",
		searchPlaceholder: "請輸入項目名稱",
		clearModelCache: "清除模型快取",
		clearModelCacheConfirm: "確認清除所有模型快取？清除後所有用戶首次載入會稍慢。",
		clearModelCacheTip: "提示",
		clearModelCacheSuccess: "快取已清除，共清除 {n} 條快取",
		newProject: "新建項目",
		colProjectId: "項目ID",
		colProjectName: "項目名稱",
		colProjectLeader: "項目負責人",
		colProjectTerm: "項目週期",
		colFollowupData: "隨訪資料",
		colViewInfo: "視圖資訊",
		colMainCenter: "主中心",
		colOperation: "操作",
		actEdit: "編輯項目",
		actScene: "應用情境",
		actDatabase: "資料庫設定",
		actFollowup: "隨訪設定",
		actPermissions: "人員權限",
		actSubCenter: "分中心管理",
		actSubProject: "子項目管理",
		actSchema: "架構初始生成",
		actAgent: "Agent設定",
		actMetadataHistory: "元數據歷史",
		actLifecycle: "生命週期與留存",
		actPiiRule: "PII規則設定",
		actConsent: "知情同意書",
		grpSetup: "設定",
		grpData: "資料",
		grpGovernance: "治理",
		grpStructure: "結構",
		lostFollowups: "丟失計劃隨訪條數 {n}",
		fixData: "修復資料",
		patientCount: "就診人:{p} ; 視圖列: {v};",
		patientViewMismatch: "---存在差異---",
		buildStatus: "建置狀態:{s} ;",
		buildBusy: "視圖建置中",
		buildIdle: "目前無任務",
		startTime: "開始時間:{t};",
		endTime: "結束時間:{t};",
		execResult: "執行結果:{r};",
		execSuccess: "成功",
		execFailed: "失敗",
		rebuildView: "重建視圖",
		appendView: "修補視圖",
		recalcCompleteness: "重算完整度",
		opSent: "請求已傳送",
		recalcDone: "重算完成，共處理 {n} 位患者",
		dialogBaseTitle: "基本資訊",
		dialogSceneTitle: "應用情境",
		fieldProjectName: "項目名稱",
		fieldProjectCode: "項目編碼",
		fieldProjectLeader: "項目負責人",
		fieldLeadCenter: "牽頭單位",
		fieldStartDate: "項目啟動日期",
		fieldEndDate: "項目結束日期",
		fieldTarget: "項目目標",
		fieldLeaderUnit: "負責人單位",
		fieldCompanyLogo: "公司Logo（橫版）",
		fieldSquareLogo: "方形Logo（圖標）",
		placeholderSelect: "請選擇",
		fieldSpecialty: "專科",
		fieldDisease: "疾病",
		fieldSoftwareEnv: "軟件環境",
		envWeb: "web",
		envDoctor: "醫生小程序",
		envPatient: "患者小程序",
		fieldLoginUrl: "項目登入頁URL",
		fieldLoginName: "項目登入頁名稱",
		fieldLoginImage: "項目登入頁圖片",
		searchPlaceholderRemote: "請輸入關鍵字",
	},
	equity: {
		accountInfo: "帳號資訊",
		username: "用戶名：",
		realNameAuth: "實名認證：",
		modify: "修改",
		notAuthHint: "目前您未完成資訊認證，無法享受五折優惠",
		goAuth: "去認證",
		levelExpire: "會員等級有效期：{date}",
		upgrade: "去升級會員",
		memberRights: "會員權益",
		categoryProjectMgmt: "項目管理",
		categoryAiCollect: "AI資料採集功能",
		categoryAiAnalysis: "AI資料分析功能",
		categoryIp: "知識產權服務",
		categoryResearch: "科研項目服務",
		rightCreateProject: "新建項目",
		rightCustomForm: "自訂表單",
		rightFollowup: "隨訪管理",
		rightEnrollment: "入組狀態管理",
		rightSubProject: "子項目管理",
		rightUnivariate: "單變數統計",
		rightSearch: "資料檢索",
		rightExport: "資料匯出",
		rightHistorical: "歷史資料入組新項目",
		rightAutoEnroll: "新資料自動納排",
		rightCrfGen: "自動生成CRF表",
		rightCrfFill: "自動填寫CRF表",
		rightPathology: "自動生成病理報告",
		rightFollowupChat: "互動式患者隨訪",
		rightAiSearch: "AI資料檢索",
		rightAiStat: "AI資料統計",
		rightAiExport: "AI資料篩選匯出",
		rightAiEnroll: "AI納排管理",
		rightIpFile: "知識產權申報",
		rightJointProject: "聯合項目申報",
		basicMember: "基礎會員",
		smartMember: "智慧會員",
		joint1Software: "免費申請聯合軟著1項",
		joint2Software: "免費申請獨立軟著2項",
		jointAiProject: "可聯合申報醫療人工智能項目",
		currentLevel: "當前等級",
		dialogAuthTitle: "資訊認證",
	},
	order: {
		searchPlaceholder: "請輸入訂單編號",
		orderList: "訂單列表",
		colIndex: "序號",
		colOrderNo: "訂單號",
		colPaymentTime: "交易時間",
		colPaymentFees: "交易金額",
		colPaymentMethod: "支付方式",
		methodWechat: "微信",
		colContent: "交易內容",
		colStatus: "目前狀態",
		colInvoiceStatus: "開票狀態",
		colOperation: "操作",
		actInvoice: "開票",
		statusCreated: "待支付",
		statusPayed: "已支付",
		statusUsed: "已使用",
		invoiceNotIssued: "未開票",
		invoiceIssued: "已開票",
		dialogTitle: "填寫開票資訊",
		titleSection: "抬頭資訊",
		fieldAmount: "發票金額",
		amountUnit: "元",
		fieldHeaderType: "抬頭類型",
		typePersonal: "個人/非企業單位",
		typeEnterprise: "企業",
		fieldInvoiceType: "發票類型",
		invoiceTypeValue: "增值稅普通電子發票",
		fieldHeader: "發票抬頭",
		placeholderInput: "請輸入",
		placeholderHeader: "請輸入發票抬頭",
		fieldTaxNumber: "納稅人識別號",
		placeholderTaxNumber: "請輸入15-20位的納稅人識別號",
	},
	subProjectManage: {
		title: "子項目列表",
		breadCrumb: "項目管理 / {parent}",
		newSubProject: "新建子項目",
		searchPlaceholder: "請輸入子項目名稱",
	},
	projectList: {
		projectCode: "項目編碼",
		centerCount: "中心數量",
		patientCount: "入組患者數量",
		subProjects: "子項目列表",
		openProject: "進入項目",
		emptyHint: "您還沒有任何項目，快去建立一個項目吧～",
		createProject: "建立項目",
		noticeSystem: "系統通知",
		noticeOcr: "OCR識別",
		noticeChallenge: "資料質疑",
	},
	projectHead: {
		projectName: "項目名稱",
		rootProjectName: "根項目名稱",
		subProjectName: "子項目名稱",
		parentProject: "關聯隊列項目",
		specialty: "關聯專科",
		disease: "關聯疾病",
		formConfig: "表單配置",
		followUpConfig: "隨訪配置",
		schemaSnapshot: "架構快照",
	},
	home: {
		leadCentre: "牽頭單位",
		maskedHospital: "****醫院",
		projectLead: "項目負責人",
		projectTerm: "項目期限",
		pendingReply: "待回覆問診",
		clickToReply: "點擊查看並回覆 →",
		totalCases: "病例總數",
		newCasesThisMonth: "本月新增病例",
		avgCompleteness: "平均完整度",
		followUpOverdue: "隨訪超窗",
		view: "查看",
		notifications: "項目通知",
		index: "序號",
		notificationType: "通知類型",
		notificationContent: "通知內容",
		count: "人數",
		enrollmentTrend: "入組情況",
		genderRatio: "男女比例",
		ageDistribution: "年齡分佈",
	},
};
